<template>
  <div class="search-container">
    <!-- Mobile Menu Button -->
    <button class="mobile-menu-btn" @click="toggleMobileSidebar" v-if="!isMobileSidebarOpen">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="currentColor"/>
      </svg>
    </button>
    
    <!-- Mobile Overlay -->
    <div class="mobile-overlay" v-if="isMobileSidebarOpen" @click="toggleMobileSidebar"></div>
    <!-- Left Sidebar -->
    <div class="left-sidebar" :class="{ 'mobile-open': isMobileSidebarOpen }">
      <!-- Mobile Close Button -->
      <button class="mobile-close-btn" @click="toggleMobileSidebar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
        </svg>
      </button>
      <!-- Logo -->
      <div class="sidebar-logo">
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2.30291" width="30" height="29.697" rx="6" stroke="#3A895F" stroke-width="4"/>
          <path d="M21.6382 2L10.0922 31.798" stroke="#3A895F" stroke-width="4"/>
          <path d="M14.1382 20.4924L32 20.4924" stroke="#3A895F" stroke-width="4"/>
        </svg>
      </div>
      
      <!-- Navigation Items -->
      <div class="sidebar-nav">
        <a href="/" class="nav-item" :class="{ 'active': !isDataIngestionPage && !isDataSourcesPage && !isAutomationsPage && !isInsightsPage && !isChatPage && !isDomainGraphPage }" @click="closeMobileSidebar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_378_314" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_378_314)">
              <path d="M11 18C12.9333 18 14.5833 17.3208 15.95 15.9625C17.3167 14.6042 18 12.95 18 11C18 9.06667 17.3167 7.41667 15.95 6.05C14.5833 4.68333 12.9333 4 11 4C9.05 4 7.39583 4.68333 6.0375 6.05C4.67917 7.41667 4 9.06667 4 11C4 12.95 4.67917 14.6042 6.0375 15.9625C7.39583 17.3208 9.05 18 11 18ZM11 20C9.75 20 8.57917 19.7625 7.4875 19.2875C6.39583 18.8125 5.44583 18.1708 4.6375 17.3625C3.82917 16.5542 3.1875 15.6042 2.7125 14.5125C2.2375 13.4208 2 12.25 2 11C2 9.76667 2.2375 8.60417 2.7125 7.5125C3.1875 6.42083 3.82917 5.46667 4.6375 4.65C5.44583 3.83333 6.39583 3.1875 7.4875 2.7125C8.57917 2.2375 9.75 2 11 2C12.2333 2 13.3958 2.2375 14.4875 2.7125C15.5792 3.1875 16.5333 3.83333 17.35 4.65C18.1667 5.46667 18.8125 6.42083 19.2875 7.5125C19.7625 8.60417 20 9.76667 20 11C20 12.0667 19.825 13.075 19.475 14.025C19.125 14.975 18.6417 15.8417 18.025 16.625L22 20.6L20.575 22L16.6 18.05C15.8167 18.6667 14.95 19.1458 14 19.4875C13.05 19.8292 12.05 20 11 20Z" fill="#6C7972"/>
            </g>
          </svg>
          <span>New search</span>
        </a>
        <a href="/chat" class="nav-item" :class="{ 'active': isChatPage }" @click="closeMobileSidebar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_chat" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_chat)">
              <path d="M6 14H14V12H6V14ZM6 11H18V9H6V11ZM6 8H18V6H6V8ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z" fill="#6C7972"/>
            </g>
          </svg>
          <span>New chat</span>
        </a>
        <a href="/data-sources" class="nav-item" :class="{ 'active': isDataSourcesPage }" @click="closeMobileSidebar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_379_2328" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_379_2328)">
              <path d="M18.6 20.4C17.9167 20.4 17.3167 20.2 16.8 19.8C16.2834 19.4 15.9334 18.9 15.75 18.3H9.90002C8.98336 18.3 8.20419 17.9792 7.56252 17.3375C6.92086 16.6958 6.60002 15.9167 6.60002 15C6.60002 14.0833 6.92086 13.3042 7.56252 12.6625C8.20419 12.0208 8.98336 11.7 9.90002 11.7H12.9C13.4775 11.7 13.9719 11.4938 14.3833 11.0813C14.7944 10.6688 15 10.1729 15 9.59376C15 9.01459 14.7944 8.52084 14.3833 8.11251C13.9719 7.70417 13.4775 7.50001 12.9 7.50001H8.25002C8.06669 8.10001 7.71669 8.60001 7.20002 9.00001C6.68336 9.40001 6.08336 9.60001 5.40002 9.60001C4.56669 9.60001 3.85836 9.30834 3.27502 8.72501C2.69169 8.14167 2.40002 7.43334 2.40002 6.60001C2.40002 5.76667 2.69169 5.05834 3.27502 4.47501C3.85836 3.89167 4.56669 3.60001 5.40002 3.60001C6.08336 3.60001 6.68336 3.80001 7.20002 4.20001C7.71669 4.60001 8.06669 5.10001 8.25002 5.70001H12.9C13.9834 5.70001 14.9042 6.07917 15.6625 6.83751C16.4209 7.59584 16.8 8.51667 16.8 9.60001C16.8 10.6833 16.4209 11.6042 15.6625 12.3625C14.9042 13.1208 13.9834 13.5 12.9 13.5H9.90002C9.48752 13.5 9.13444 13.6473 8.84078 13.942C8.54694 14.2365 8.40002 14.5907 8.40002 15.0045C8.40002 15.4182 8.54694 15.7708 8.84078 16.0625C9.13444 16.3542 9.48752 16.5 9.90002 16.5H15.75C15.9334 15.9 16.2834 15.4 16.8 15C17.3167 14.6 17.9167 14.4 18.6 14.4C19.4334 14.4 20.1417 14.6917 20.725 15.275C21.3084 15.8583 21.6 16.5667 21.6 17.4C21.6 18.2333 21.3084 18.9417 20.725 19.525C20.1417 20.1083 19.4334 20.4 18.6 20.4ZM5.40002 7.80001C5.74002 7.80001 6.02502 7.68501 6.25502 7.45501C6.48502 7.22501 6.60002 6.94001 6.60002 6.60001C6.60002 6.26001 6.48502 5.97501 6.25502 5.74501C6.02502 5.51501 5.74002 5.40001 5.40002 5.40001C5.06002 5.40001 4.77502 5.51501 4.54502 5.74501C4.31502 5.97501 4.20002 6.26001 4.20002 6.60001C4.20002 6.94001 4.31502 7.22501 4.54502 7.45501C4.77502 7.68501 5.06002 7.80001 5.40002 7.80001Z" fill="#6C7972"/>
            </g>
          </svg>
          <span>Data sources</span>
        </a>
        <a href="/data-ingestion" class="nav-item" :class="{ 'active': isDataIngestionPage }" @click="closeMobileSidebar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_379_2400" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_379_2400)">
              <path d="M11 16H13V13H16V11H13V8H11V11H8V13H11V16ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z" fill="#6C7972"/>
            </g>
          </svg>
          <span>Data Ingestion</span>
        </a>
        <a href="/domain-graph" class="nav-item" :class="{ 'active': isDomainGraphPage }" @click="closeMobileSidebar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="5" r="3" stroke="#6C7972" stroke-width="2"/>
            <circle cx="6" cy="12" r="3" stroke="#6C7972" stroke-width="2"/>
            <circle cx="18" cy="19" r="3" stroke="#6C7972" stroke-width="2"/>
            <line x1="8.5" y1="10.5" x2="15.5" y2="6.5" stroke="#6C7972" stroke-width="2"/>
            <line x1="8.5" y1="13.5" x2="15.5" y2="17.5" stroke="#6C7972" stroke-width="2"/>
          </svg>
          <span>Domain Graph</span>
        </a>
      </div>
      
      <!-- Recent Section -->
      <div class="sidebar-section" v-if="recentItems.length > 0">
        <h3 class="section-title">Recent</h3>
        <div class="recent-items">
          <a 
            href="#" 
            v-for="(item, index) in recentItems" 
            :key="index"
            @click.prevent="selectRecentItem(item)"
            class="recent-item"
          >
            <span class="recent-item-type">{{ item.type }}</span>
            <span class="recent-item-name">{{ item.name }}</span>
          </a>
        </div>
      </div>
      
      <!-- Industry Selector -->
      <IndustrySelector @industry-changed="handleIndustryChange" />
    </div>
    
    <!-- Main Content Area -->
    <div class="main-content" :class="{'with-ai-panel': selectedItem && !isMobileAIPanelOpen}">
      <!-- Mobile AI Panel Toggle Button -->
      <button 
        class="mobile-ai-toggle-btn" 
        v-if="selectedItem" 
        @click="toggleMobileAIPanel"
        :class="{ 'panel-open': isMobileAIPanelOpen }"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" fill="currentColor"/>
        </svg>
        <span>AI Assistant</span>
      </button>
      
      <!-- Main Container -->
      <div class="main-container" :class="{'full-width': showingPreAuditGuidance || showingAuditFindings}">
        <div class="ai-panel-wrapper" :class="{ 'mobile-open': isMobileAIPanelOpen }">
          <!-- Mobile AI Panel Close Button -->
          <button class="mobile-ai-close-btn" @click="toggleMobileAIPanel" v-if="isMobileAIPanelOpen">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
            </svg>
          </button>
          <AIAssistantPanel 
            v-if="selectedItem"
            :supplyChainData="{...selectedItem, ...itemDetails, classerInfo: itemDetails.classer}" 
            :activeTab="activeTab"
            @process-audit-report="handleAuditReport"
          />
        </div>
        <!-- Pre-Audit Guidance Component -->
        <PreAuditGuidance
          v-if="showingPreAuditGuidance"
          :farmName="selectedFarm?.name || 'Ironbark Station'"
          :processedAuditReport="processedAuditReport"
          @back="backToDetail"
        />

        <!-- Audit Findings Component -->
        <AuditFindings
          v-if="showingAuditFindings"
          :farmName="selectedFarm?.name || 'Ironbark Station'"
          @back="backToDetail"
          @show-pre-audit-guidance="showPreAuditGuidance"
        />
        <!-- Content Slot - Used for custom pages like Data Ingestion or Data Sources -->
        <slot name="content">
          <!-- Data Ingestion Content -->
          <div v-if="isDataIngestionPage" class="data-ingestion-wrapper">
            <data-ingestion-upload></data-ingestion-upload>
          </div>
          <!-- Data Sources Content -->
          <div v-else-if="isDataSourcesPage" class="data-sources-wrapper">
            <data-sources-page></data-sources-page>
          </div>
          <!-- Domain Graph Content -->
          <div v-else-if="isDomainGraphPage" class="domain-graph-wrapper">
            <domain-graph-page></domain-graph-page>
          </div>
          <!-- Automations Content -->
          <div v-else-if="isAutomationsPage" class="automations-wrapper">
            <automations-page></automations-page>
          </div>
          <!-- Insights Content -->
          <div v-else-if="isInsightsPage" class="insights-wrapper">
            <insights-page></insights-page>
          </div>
          
          <!-- Chat Content -->
          <div v-else-if="isChatPage" class="chat-wrapper">
            <!-- Chat Title -->
            <div class="chat-page-header">
              <h1 class="chat-page-title">Chat</h1>
              <div class="chat-page-separator"></div>
            </div>
            
            <!-- Custom Chat Interface -->
            <div class="custom-chat-container">
              <!-- Messages Area -->
              <div class="custom-chat-messages" ref="customChatMessages">
                <!-- Bot Messages -->
                <div 
                  v-for="(message, index) in customChatMessages" 
                  :key="index"
                  class="custom-message-wrapper"
                  :class="message.role"
                >
                  <div class="custom-message-bubble" :class="message.role">
                    <div class="custom-message-content" v-html="message.content"></div>
                    <!-- Chart Container -->
                    <div v-if="message.chartData" class="message-chart-container">
                      <canvas :ref="'chart-' + index" :id="'chart-' + index"></canvas>
                    </div>
                  </div>
                </div>
                
                <!-- Loading Indicator -->
                <div v-if="customChatLoading" class="custom-message-wrapper bot">
                  <div class="custom-loading-container">
                    <svg width="24" height="24" viewBox="0 0 164 159" fill="none" xmlns="http://www.w3.org/2000/svg" class="custom-loading-icon">
                      <title>Loading...</title>
                      <defs>
                        <linearGradient id="chat-loading-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#8FD4B3" />
                          <stop offset="50%" stop-color="#C8F0DF" />
                          <stop offset="100%" stop-color="#8FD4B3" />
                        </linearGradient>
                        <filter id="chat-soft-glow" x="-50%" y="-50%" width="200%" height="200%">
                          <feGaussianBlur stdDeviation="1" result="blur"/>
                          <feMerge>
                            <feMergeNode in="blur"/>
                            <feMergeNode in="SourceGraphic"/>
                          </feMerge>
                        </filter>
                      </defs>
                      <path d="M105.5 4.5L47 152" stroke="#3A895F" stroke-width="12"/>
                      <path d="M67.5 96.0376L158 96.0376" stroke="#3A895F" stroke-width="12"/>
                      <rect x="6" y="6" width="152" height="147" rx="24" stroke="#3A895F" stroke-width="12" fill="none"/>
                      <rect class="chat-loader-overlay" x="6" y="6" width="152" height="147" rx="24" stroke="url(#chat-loading-gradient)" stroke-width="10" fill="none" filter="url(#chat-soft-glow)"/>
                    </svg>
                    <span class="custom-loading-text">{{ currentLoadingMessage }}</span>
                  </div>
                </div>
              </div>
              
              <!-- Input Area -->
              <div class="custom-chat-input-container">
                <div class="custom-chat-input-wrapper">
                  <input
                    v-model="customChatInput"
                    @keydown.enter.prevent="handleCustomChatSubmit"
                    placeholder="Ask a follow-up"
                    class="custom-chat-input"
                    type="text"
                  />
                  <div class="custom-chat-buttons">
                    <button class="custom-chat-icon-btn" title="Voice input">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 14C13.1 14 14.05 13.6 14.85 12.8C15.65 12 16.05 11.05 16.05 9.95V5C16.05 3.9 15.65 2.95 14.85 2.15C14.05 1.35 13.1 0.95 12 0.95C10.9 0.95 9.95 1.35 9.15 2.15C8.35 2.95 7.95 3.9 7.95 5V10C7.95 11.1 8.35 12.05 9.15 12.85C9.95 13.65 10.9 14.05 12 14.05M10.5 5C10.5 4.6 10.65 4.25 10.95 3.95C11.25 3.65 11.6 3.5 12 3.5C12.4 3.5 12.75 3.65 13.05 3.95C13.35 4.25 13.5 4.6 13.5 5V10C13.5 10.4 13.35 10.75 13.05 11.05C12.75 11.35 12.4 11.5 12 11.5C11.6 11.5 11.25 11.35 10.95 11.05C10.65 10.75 10.5 10.4 10.5 10V5ZM11 21V18.1C9.2 17.9 7.7 17.15 6.5 15.85C5.3 14.55 4.7 13 4.7 11.2H6.2C6.2 12.65 6.7 13.9 7.7 14.95C8.7 16 9.95 16.5 11.5 16.5C13.05 16.5 14.3 16 15.3 14.95C16.3 13.9 16.8 12.65 16.8 11.2H18.3C18.3 13 17.7 14.55 16.5 15.85C15.3 17.15 13.8 17.9 12 18.1V21H11Z" fill="#9CA3AF"/>
                      </svg>
                    </button>
                    <button class="custom-chat-icon-btn" title="Attach file">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.5 6V17.5C16.5 19.433 14.933 21 13 21C11.067 21 9.5 19.433 9.5 17.5V5C9.5 3.62 10.62 2.5 12 2.5C13.38 2.5 14.5 3.62 14.5 5V15.5C14.5 16.327 13.827 17 13 17C12.173 17 11.5 16.327 11.5 15.5V6H10V15.5C10 17.157 11.343 18.5 13 18.5C14.657 18.5 16 17.157 16 15.5V5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5V17.5C8 20.263 10.237 22.5 13 22.5C15.763 22.5 18 20.263 18 17.5V6H16.5Z" fill="#9CA3AF"/>
                      </svg>
                    </button>
                    <button 
                      @click="handleCustomChatSubmit"
                      :disabled="!customChatInput.trim() || customChatLoading"
                      class="custom-chat-go-btn"
                    >
                      <span v-if="!customChatLoading">Go</span>
                      <svg v-else class="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Default Search Form -->
          <div v-else-if="viewMode === 'search'" class="search-form-container" :class="{ 'with-results': hasSearched && searchResults && searchResults.count > 0 }" style="max-width: 900px !important;">
            <div class="search-header text-center" :class="{ 'mb-reduced': hasSearched && searchResults && searchResults.count > 0 }">
              <h1 class="text-2xl font-medium text-gray-800">{{ greeting }}</h1>
              <p class="text-lg font-bold mt-2" style="color: #93A099;">What can Atralis help you with?</p>
            </div>
        
        <div class="search-box mx-auto" style="max-width: 800px !important; width: 100% !important;" :class="{ 
          'mt-12': !(hasSearched), 
          'mt-6': hasSearched && searchResults && searchResults.count > 0,
          'mt-3': hasSearched && loading
        }">
          <div class="relative">
            <div class="relative">
              <div class="absolute left-4 top-1/2 transform -translate-y-1/2 pointer-events-none hidden sm:block">
                <svg class="w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_536_362" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_536_362)">
                    <path d="M9.16663 15C10.7777 15 12.1527 14.434 13.2916 13.3021C14.4305 12.1701 15 10.7917 15 9.16666C15 7.55555 14.4305 6.18055 13.2916 5.04166C12.1527 3.90277 10.7777 3.33332 9.16663 3.33332C7.54163 3.33332 6.16315 3.90277 5.03121 5.04166C3.89926 6.18055 3.33329 7.55555 3.33329 9.16666C3.33329 10.7917 3.89926 12.1701 5.03121 13.3021C6.16315 14.434 7.54163 15 9.16663 15ZM9.16663 16.6667C8.12496 16.6667 7.14926 16.4687 6.23954 16.0729C5.32982 15.6771 4.53815 15.1424 3.86454 14.4687C3.19093 13.7951 2.65621 13.0035 2.26038 12.0937C1.86454 11.184 1.66663 10.2083 1.66663 9.16666C1.66663 8.13888 1.86454 7.17013 2.26038 6.26041C2.65621 5.35068 3.19093 4.55555 3.86454 3.87499C4.53815 3.19443 5.32982 2.65624 6.23954 2.26041C7.14926 1.86457 8.12496 1.66666 9.16663 1.66666C10.1944 1.66666 11.1632 1.86457 12.0729 2.26041C12.9826 2.65624 13.7777 3.19443 14.4583 3.87499C15.1388 4.55555 15.677 5.35068 16.0729 6.26041C16.4687 7.17013 16.6666 8.13888 16.6666 9.16666C16.6666 10.0555 16.5208 10.8958 16.2291 11.6875C15.9375 12.4792 15.5347 13.2014 15.0208 13.8542L18.3333 17.1667L17.1458 18.3333L13.8333 15.0417C13.1805 15.5555 12.4583 15.9549 11.6666 16.2396C10.875 16.5243 10.0416 16.6667 9.16663 16.6667Z" fill="#3A895F"/>
                  </g>
                </svg>
              </div>
              <input 
                type="text" 
                v-model="searchQuery" 
                placeholder="Find or ask anything" 
                class="w-full pl-4 sm:pl-12 pr-14 sm:pr-24 py-3 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-600 text-sm sm:text-base"
                style="background-color: #FAFBFB; border: 2px solid #E7EEEA;"
                @keyup.enter="performSearch"
                @input="handleSearchInput"
                @focus="showSuggestions = true"
                @blur="hideSuggestionsDelayed"
              />
              
              <!-- Autocomplete Suggestions Dropdown -->
              <div v-if="showSuggestions && suggestions.length > 0" class="absolute left-0 right-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 z-50 max-h-96 overflow-y-auto">
                <div class="p-2">
                  <div class="text-xs text-gray-500 px-3 py-2 font-medium">Suggestions</div>
                  <button
                    v-for="(suggestion, index) in suggestions"
                    :key="index"
                    @mousedown.prevent="selectSuggestion(suggestion)"
                    class="w-full text-left px-3 py-2 hover:bg-gray-50 rounded-md flex items-center space-x-3 transition-colors"
                  >
                    <div class="flex-shrink-0">
                      <span class="inline-block px-2 py-1 text-xs font-semibold rounded" :class="{
                        'bg-green-100 text-green-800': suggestion.type === 'farm',
                        'bg-blue-100 text-blue-800': suggestion.type === 'wool_line',
                        'bg-purple-100 text-purple-800': suggestion.type === 'factory',
                        'bg-yellow-100 text-yellow-800': suggestion.type === 'export',
                        'bg-gray-100 text-gray-800': !['farm', 'wool_line', 'factory', 'export'].includes(suggestion.type)
                      }">
                        {{ formatSuggestionType(suggestion.type) }}
                      </span>
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="text-sm font-medium text-gray-900 truncate">{{ suggestion.name }}</div>
                      <div v-if="suggestion.description" class="text-xs text-gray-500 truncate">{{ suggestion.description }}</div>
                    </div>
                  </button>
                </div>
              </div>
              <button 
                @click="performSearch" 
                class="absolute right-2 top-1/2 transform -translate-y-1/2 text-white font-medium transition duration-200 flex items-center justify-center text-xs sm:text-sm w-9 h-8 sm:w-11 sm:h-9"
                style="border-radius: 4px;"
                :style="{ 
                  backgroundColor: loading ? '#9CA3AF' : '#3A895F', 
                  opacity: loading ? '0.7' : '1'
                }"
                :disabled="loading"
              >
                <span>Go</span>
              </button>
            </div>
            <div class="mt-4">
              <div class="flex items-center">
                <label for="deepSearch" class="inline-flex relative items-center cursor-pointer">
                  <input type="checkbox" id="deepSearch" v-model="deepSearchEnabled" class="sr-only" />
                  <div class="toggle-bg bg-gray-200 rounded-full w-11 h-6 transition-colors duration-200 ease-in-out" :style="{ backgroundColor: deepSearchEnabled ? '#3A895F' : '' }"></div>
                  <div class="toggle-dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200 ease-in-out" :class="{ 'transform translate-x-5': deepSearchEnabled }"></div>
                  <span class="ml-3 text-sm text-gray-600">Deep research enabled</span>
                </label>
              </div>
              
              <!-- Loading indicator below the toggle -->
              <div v-if="viewMode === 'search' && hasSearched && loading" class="flex items-center justify-center mt-6">
                <svg width="24" height="24" viewBox="0 0 164 159" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <title>Loading...</title>
                  <defs>
                    <linearGradient id="loading-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stop-color="#8FD4B3" />
                      <stop offset="50%" stop-color="#C8F0DF" />
                      <stop offset="100%" stop-color="#8FD4B3" />
                    </linearGradient>
                    <filter id="soft-glow" x="-50%" y="-50%" width="200%" height="200%">
                      <feGaussianBlur stdDeviation="1" result="blur"/>
                      <feMerge>
                        <feMergeNode in="blur"/>
                        <feMergeNode in="SourceGraphic"/>
                      </feMerge>
                    </filter>
                  </defs>
                  <path d="M105.5 4.5L47 152" stroke="#3A895F" stroke-width="12"/>
                  <path d="M67.5 96.0376L158 96.0376" stroke="#3A895F" stroke-width="12"/>
                  <rect x="6" y="6" width="152" height="147" rx="24" stroke="#3A895F" stroke-width="12" fill="none"/>
                  <rect id="loader-overlay" x="6" y="6" width="152" height="147" rx="24" stroke="url(#loading-gradient)" stroke-width="10" fill="none" filter="url(#soft-glow)"/>
                </svg>
                <p class="text-base font-medium text-green-700">Searching for results...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      </slot>
      
      <!-- Search Results -->
      <div v-if="viewMode === 'search' && hasSearched && searchResults && searchResults.count > 0" class="search-results">
        <div class="results-header">
          <h2 class="text-xl font-semibold text-gray-800">Search Results</h2>
          <p class="text-gray-600">Found {{ searchResults.count }} results for "{{ searchQuery }}"</p>
          
          <div class="flex justify-between items-center mt-4">
            <div class="flex gap-2">
              <button 
                class="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                :class="{ 'bg-gray-100': filterOptions.compliance }"
                @click="filterOptions.compliance = !filterOptions.compliance"
              >
                Compliance
              </button>
              <button 
                class="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                :class="{ 'bg-gray-100': filterOptions.sustainability }"
                @click="filterOptions.sustainability = !filterOptions.sustainability"
              >
                Sustainability
              </button>
              <button 
                class="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                :class="{ 'bg-gray-100': filterOptions.regulatory }"
                @click="filterOptions.regulatory = !filterOptions.regulatory"
              >
                Regulatory
              </button>
              <button 
                class="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                :class="{ 'bg-gray-100': filterOptions.risks }"
                @click="filterOptions.risks = !filterOptions.risks"
              >
                Risks
              </button>
            </div>
            
            <div class="relative">
              <button 
                @click="toggleSortDropdown" 
                class="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center gap-1"
              >
                Sort by: {{ sortOption }} <span>▼</span>
              </button>
              <div v-if="showSortDropdown" class="sort-dropdown absolute right-0 mt-1 bg-white shadow-lg rounded-md border border-gray-200 z-10">
                <button 
                  @click="setSortOption('Type')" 
                  class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Type
                </button>
                <button 
                  @click="setSortOption('Origin')" 
                  class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Origin
                </button>
                <button 
                  @click="setSortOption('Destination')" 
                  class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Destination
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="results-body mt-6">
          <div v-for="group in groupedResults" :key="group.category" class="result-group mb-8">
            <h3 class="text-lg font-medium text-gray-700 mb-3">{{ group.category }}</h3>
            
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div 
                v-for="item in group.items" 
                :key="item.id" 
                class="result-card bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition duration-200 cursor-pointer"
                @click="showDetails(item)"
              >
                <div class="p-4">
                  <div class="flex justify-between items-start">
                    <!-- Content on the left -->
                    <div>
                      <!-- Commercial entity type badge -->
                      <span v-if="isCommercialEntity(item.type)" class="inline-block px-2 py-1 text-xs font-semibold rounded-md" :class="{
                        'bg-blue-100 text-blue-800': item.type === 'classer',
                        'bg-indigo-100 text-indigo-800': item.type === 'testing_lab',
                        'bg-orange-100 text-orange-800': item.type === 'broker',
                        'bg-red-100 text-red-800': item.type === 'auction_house',
                        'bg-teal-100 text-teal-800': item.type === 'shipping_company',
                        'bg-purple-100 text-purple-800': item.type === 'factory',
                        'bg-pink-100 text-pink-800': item.type === 'brand',
                        'bg-green-100 text-green-800': item.type === 'certification_body',
                        'bg-gray-100 text-gray-800': item.type === 'government_agency'
                      }">
                        {{ formatEntityType(item.type) }}
                      </span>
                      
                      <!-- Other type badges -->
                      <span v-else-if="item.type !== 'farm' && item.type !== 'wool_line'" class="inline-block px-2 py-1 text-xs font-semibold rounded-md" :class="{
                        'bg-purple-100 text-purple-800': item.type === 'factory',
                        'bg-yellow-100 text-yellow-800': item.type === 'export'
                      }">
                        {{ item.type }}
                      </span>
                      
                      <h4 class="font-semibold text-gray-800 mt-2">{{ item.name || item.code }}</h4>
                    </div>
                    
                    <!-- Logo on the right for commercial entities -->
                    <div v-if="isCommercialEntity(item.type)" class="ml-3">
                      <div class="w-24 h-24 bg-gray-100 rounded-md flex items-center justify-center overflow-hidden">
                        <img v-if="item.logo_url" :src="item.logo_url" :alt="item.name + ' logo'" class="max-w-full max-h-full object-contain" />
                        <img v-else-if="item.type === 'shipping_company'" src="/images/logos/shipping-logo.png" :alt="item.name + ' logo'" class="max-w-full max-h-full object-contain" />
                        <div v-else class="text-3xl font-bold text-gray-300">{{ item.name ? item.name.charAt(0).toUpperCase() : 'E' }}</div>
                      </div>
                    </div>
                    <!-- Show certification badge if available (but not for farms or shipping companies) -->
                    <div v-if="item.certification && item.type !== 'farm' && item.type !== 'shipping_company'" class="certification-badge">
                      <span class="inline-block px-2 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-full">
                        {{ item.certification }}
                      </span>
                    </div>
                  </div>
                  
                  <div class="mt-3 text-sm text-gray-600">
                    <!-- Different display for different entity types -->
                    <template v-if="item.type === 'farm'">
                      <div><strong>Location:</strong> {{ item.region }}{{ item.LGA ? ', ' + item.LGA : '' }}</div>
                      <div><strong>Owner:</strong> {{ item.OwnerName || 'Unknown' }}</div>
                    </template>
                    <template v-else-if="isCommercialEntity(item.type)">
                      <div><strong>Location:</strong> {{ item.location || 'N/A' }}</div>
                      <div><strong>{{ item.type === 'classer' ? 'Active since' : 'Business type' }}:</strong> {{ item.active_since || formatEntityType(item.type) }}</div>
                    </template>
                    <template v-else>
                      <div>
                        
                        <strong>Origin:</strong> 
                        <span v-if="item.origin_farm && item.PIC">
                          <span class="text-[#3A895F] cursor-pointer hover:underline" @click.stop="navigateToFarm(item.PIC, item.origin_farm)">{{ item.origin_farm }}</span>
                        </span>
                        <span v-else>{{ item.origin_farm || 'N/A' }}</span>
                      </div>
                      <div><strong>Destination:</strong> {{ item.destination || 'N/A' }}</div>
                      <div v-if="item.processing_time"><strong>Processing Time:</strong> {{ item.processing_time }}</div>
                    </template>
                  </div>
                  
                  <!-- Contextual Insights -->
                  <div v-if="item.contextualInsights" class="mt-3 pt-3 border-t border-gray-100">
                    <div class="flex items-center text-xs text-gray-500 space-x-2">
                      <svg class="w-4 h-4 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span class="font-medium">{{ item.contextualInsights }}</span>
                    </div>
                  </div>
                  
                  <div class="mt-3 flex justify-between items-center">
                    <div class="text-xs text-gray-500">Last updated: {{ item.updated_at || 'Unknown' }}</div>
                    <button class="text-green-600 hover:text-green-700 text-sm font-medium">View Details →</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            <!-- Detail View -->
      <div v-if="viewMode === 'detail' && selectedItem" class="item-detail-view">
        <!-- Back button and header -->
        <div class="detail-header">
          <button @click="backToSearch" class="back-button flex items-center text-gray-600 hover:text-gray-900">
            <span class="mr-1">←</span> Back to search
          </button>
          
          <div class="mt-4 mb-6">
            <div class="flex items-center justify-between">
              <div>
                <!-- Show type badge for commercial entities -->
                <span v-if="isCommercialEntity(selectedItem.type)" class="inline-block px-2 py-1 text-xs font-semibold rounded-md mb-2" :class="{
                  'bg-blue-100 text-blue-800': selectedItem.type === 'classer',
                  'bg-indigo-100 text-indigo-800': selectedItem.type === 'testing_lab',
                  'bg-orange-100 text-orange-800': selectedItem.type === 'broker',
                  'bg-red-100 text-red-800': selectedItem.type === 'auction_house',
                  'bg-teal-100 text-teal-800': selectedItem.type === 'shipping_company',
                  'bg-purple-100 text-purple-800': selectedItem.type === 'factory',
                  'bg-pink-100 text-pink-800': selectedItem.type === 'brand',
                  'bg-green-100 text-green-800': selectedItem.type === 'certification_body',
                  'bg-gray-100 text-gray-800': selectedItem.type === 'government_agency'
                }">
                  {{ formatEntityType(selectedItem.type) }}
                </span>
                <!-- Show type badge for other non-farm and non-wool_line items -->
                <span v-else-if="selectedItem.type !== 'farm' && selectedItem.type !== 'wool_line'" class="inline-block px-2 py-1 text-xs font-semibold rounded-md mb-2" :class="{
                  'bg-purple-100 text-purple-800': selectedItem.type === 'factory',
                  'bg-yellow-100 text-yellow-800': selectedItem.type === 'export'
                }">
                  {{ selectedItem.type }}
                </span>
                <h1 class="text-2xl font-bold text-gray-900" v-if="selectedItem.type === 'farm'">Search results for <span class="text-[#3A895F]">{{ selectedItem.name }}</span></h1>
                <div v-else-if="selectedItem.type === 'wool_line'" class="flex justify-between items-start">
                  <div class="flex-1">
                    <h1 class="text-2xl font-bold text-gray-900">
                      Search results for <span class="text-[#3A895F]">{{ selectedItem.code || selectedItem.name }}</span>
                      <div class="mt-2 text-lg">
                        <span v-if="selectedItem.FarmName && selectedItem.PIC">
                          From {{ selectedItem.FarmName }} ({{ selectedItem.PIC }})
                        </span>
                      </div>
                    </h1>
                  </div>
                  <button
                    @click="openAIInsights"
                    class="ml-4 flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
                  >
                    <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Insights</span>
                  </button>
                </div>
                <h1 class="text-2xl font-bold text-gray-900" v-else>{{ selectedItem.name || selectedItem.code }}</h1>
              </div>
              
              <!-- Show certification badge only for non-farm and non-shipping company items -->
              <div v-if="selectedItem.certification && selectedItem.type !== 'farm' && selectedItem.type !== 'shipping_company'" class="certification-badge">
                <span class="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full">
                  {{ selectedItem.certification }}
                </span>
              </div>
            </div>
            
            <p class="text-gray-600 mt-2" v-if="selectedItem.type !== 'farm' && !selectedItem.description?.includes('Wool line from')">{{ selectedItem.description || 'No description available' }}</p>
          </div>
        </div>
        
        <!-- Farm-specific header with images when viewing a farm -->
        <div v-if="selectedItem.type === 'farm'" class="farm-header mb-6">
          <div class="farm-images grid grid-cols-3 gap-4">
            <div class="farm-image rounded-lg overflow-hidden">
              <img :src="getFarmImage(1)" :alt="getFarmImageAlt(1)" class="w-full h-48 object-cover">
            </div>
            <div class="farm-image rounded-lg overflow-hidden">
              <img :src="getFarmImage(2)" :alt="getFarmImageAlt(2)" class="w-full h-48 object-cover">
            </div>
            <div class="farm-image rounded-lg overflow-hidden">
              <img :src="getFarmImage(3)" :alt="getFarmImageAlt(3)" class="w-full h-48 object-cover">
            </div>
          </div>
          
          <div class="farm-description mt-4">
            <div class="flex justify-between items-start">
              <p class="text-gray-700 flex-1">
                {{ selectedItem.name }}, located in the {{ farmDetails.location }}, is owned and operated by {{ farmDetails.owner || selectedItem.OwnerName || 'the farm owner' }} and specializes in dual-enterprise farming with prime lamb production alongside crop cultivation including wheat, canola, and chickpeas. The farm leverages the region's fertile soils and reliable rainfall to maintain sustainable agriculture practices across both livestock and cropping operations.
              </p>
              <button
                @click="openAIInsights"
                class="ml-4 flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
              >
                <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Insights</span>
              </button>
            </div>
          </div>
        </div>
        
        <!-- Tab Navigation - Different tabs for farms vs wool lines vs commercial entities -->
        <div class="tab-navigation">
          <nav class="flex border-b border-gray-200">
            <!-- Farm tabs -->
            <template v-if="selectedItem.type === 'farm'">
              <button 
                @click="activeTab = 'details'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'details' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Farm Details
              </button>
              <button 
                @click="activeTab = 'data-sources'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'data-sources' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Data Sources
              </button>
              <button 
                @click="activeTab = 'connections'; loadConnectionsData()" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'connections' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Connections Graph
              </button>
              <button 
                @click="activeTab = 'audit'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'audit' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Audit & Compliance
              </button>
              <button 
                @click="activeTab = 'files'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'files' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Files
              </button>
            </template>
            
            <!-- Commercial entity tabs -->
            <template v-else-if="isCommercialEntity(selectedItem.type)">
              <button 
                @click="activeTab = 'details'" 
                class="px-4 py-2 text-sm font-medium rounded-t-md" 
                :class="activeTab === 'details' ? 'text-green-600 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'"
              >
                Details
              </button>
              <button 
                @click="activeTab = 'connections'; loadConnectionsData()"
                class="px-4 py-2 text-sm font-medium rounded-t-md" 
                :class="activeTab === 'connections' ? 'text-green-600 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'"
              >
                Connections Graph
              </button>
              <button 
                @click="activeTab = 'files'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'files' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Files & Documents
              </button>
            </template>
            
            <!-- Wool line tabs -->
            <template v-else>
              <button 
                @click="activeTab = 'list-view'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'list-view' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Overview
              </button>
              <button 
                @click="activeTab = 'supply-chain'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'supply-chain' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Supply Chain
              </button>
              <button 
                @click="activeTab = 'connections-graph'; loadConnectionsData()" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'connections-graph' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Connections Graph
              </button>
              <button 
                @click="activeTab = 'files'" 
                class="px-4 py-2 text-sm font-medium border-b-2 -mb-px" 
                :class="activeTab === 'files' ? 'border-green-600 text-green-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
              >
                Files & Documents
              </button>
            </template>
          </nav>
        </div>
        
        <!-- Tab Content -->
        <!-- Connections Graph Tab (for both farms and commercial entities) -->
        <div v-if="activeTab === 'connections'" class="tab-content connections-graph-tab">
          <div class="bg-white shadow rounded-lg p-6 mt-6">
            <h2 class="text-lg font-medium text-green-700 mb-4">Supply Chain Connections</h2>
            
            <div v-if="loadingConnections" class="flex justify-center items-center py-12">
              <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
            </div>
            
            <div v-else-if="connectionData.length === 0" class="py-8 text-center">
              <p class="text-gray-500">No connection data available for this {{ selectedItem.type }}.</p>
            </div>
            
            <div v-else>
              <ConnectionsGraph 
                :rootEntity="selectedItem" 
                :connections="connectionData"
                @navigate-to-node="navigateToNode"
              />            
            </div>
          </div>
        </div>
        
        <!-- Commercial Entity Detail View -->
        <div v-if="activeTab === 'details' && isCommercialEntity(selectedItem.type)" class="tab-content commercial-entity-details-tab">
          <div class="bg-white shadow rounded-lg p-6 mt-6">
            <!-- Two-column layout with logo on right -->
            <div class="flex">
              <!-- Left column: Entity info and details -->
              <div class="w-2/3 pr-8">
                <!-- Entity Header -->
                <div class="mb-6">
                  <div class="flex justify-between items-start">
                    <div class="flex-1">
                      <h2 class="text-xl font-bold text-gray-800">{{ selectedItem.name }}</h2>
                      <p class="text-sm text-gray-600 mt-1">{{ formatEntityType(selectedItem.type) }}</p>
                      <div v-if="selectedItem.certification" class="mt-2">
                        <span class="inline-block px-2 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-md">
                          {{ selectedItem.certification }}
                        </span>
                      </div>
                    </div>
                    <button
                      @click="openAIInsights"
                      class="ml-4 flex items-center space-x-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md text-sm"
                    >
                      <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>Insights</span>
                    </button>
                  </div>
                </div>
                
                <!-- Entity Info Section -->
                <div class="border-t border-gray-100 pt-6">
                  <div class="grid grid-cols-2 gap-6 mb-8">
                    <!-- Always show these common fields -->
                    <div>
                      <h3 class="text-md font-medium text-gray-700 mb-3">Entity Type</h3>
                      <p class="text-gray-900">{{ formatEntityType(selectedItem.type) }}</p>
                    </div>
                    <div v-if="selectedItem.location">
                      <h3 class="text-md font-medium text-gray-700 mb-3">Location</h3>
                      <p class="text-gray-900">{{ selectedItem.location }}</p>
                    </div>
                    <div v-if="selectedItem.code">
                      <h3 class="text-md font-medium text-gray-700 mb-3">Code/ID</h3>
                      <p class="text-gray-900">{{ selectedItem.code }}</p>
                    </div>
                    <div v-if="selectedItem.certification">
                      <h3 class="text-md font-medium text-gray-700 mb-3">Certification</h3>
                      <p class="text-gray-900">{{ selectedItem.certification }}</p>
                    </div>
                  
                    <!-- Dynamically show fields with data -->
                    <template v-for="(value, key) in entityFields" :key="key">
                      <div v-if="value && !['id', 'type', 'name', 'code', 'description', 'location', 'certification', 'contact_info', 'updated_at', 'logo_url'].includes(key.toLowerCase())">
                        <h3 class="text-md font-medium text-gray-700 mb-3">{{ formatFieldName(key) }}</h3>
                        <p class="text-gray-900">{{ value }}</p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              
              <!-- Right column: Logo -->
              <div class="w-1/3 flex justify-center">
                <div class="w-48 h-48 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
                  <img v-if="selectedItem.logo_url" :src="selectedItem.logo_url" :alt="selectedItem.name + ' logo'" class="max-w-full max-h-full object-contain" />
                  <div v-else class="text-6xl font-bold text-gray-300">{{ selectedItem.name ? selectedItem.name.charAt(0).toUpperCase() : 'E' }}</div>
                </div>
              </div>
            </div>
            
            <!-- Description Section -->
            <div v-if="selectedItem.description" class="mb-8">
              <h2 class="text-lg font-medium text-green-700 mb-4">About</h2>
              <p class="text-gray-600 mb-4">{{ selectedItem.description }}</p>
            </div>
            
            <!-- Contact Information Section -->
            <div v-if="selectedItem.contact_info" class="mb-8">
              <h2 class="text-lg font-medium text-green-700 mb-4">Contact Information</h2>
              <p class="text-gray-600 mb-4">{{ selectedItem.contact_info }}</p>
            </div>
            
            <!-- Related Supply Chain Section -->
            <div v-if="relatedItems && relatedItems.length > 0" class="mb-8">
              <h2 class="text-lg font-medium text-green-700 mb-4">Supply Chain Involvement</h2>
              
              <div class="border-t border-gray-200">
                <!-- Table Header for Shipping Companies -->
                <div v-if="selectedItem.type === 'shipping_company'" class="py-2 border-b border-gray-200 flex items-center bg-gray-50 px-4">
                  <div class="text-xs font-semibold text-gray-500 w-1/4">Wool Line</div>
                  <div class="text-xs font-semibold text-gray-500 w-1/4">Port</div>
                  <div class="text-xs font-semibold text-gray-500 w-1/4">Farm</div>
                  <div class="text-xs font-semibold text-gray-500 w-1/4">Date</div>
                </div>
                
                <!-- Table Rows -->
                <div v-for="(item, index) in relatedItems" :key="index" 
                  class="py-4 border-b border-gray-200 flex items-center cursor-pointer hover:bg-gray-50 px-4"
                  @click="navigateToItem(item)">
                  <!-- For shipping companies, use the new layout with columns aligned to header -->
                  <template v-if="selectedItem.type === 'shipping_company'">
                    <div class="text-sm font-medium text-gray-900 w-1/4">{{ item.lineId || 'Unknown' }}</div>
                    <div class="text-sm text-gray-500 w-1/4">{{ item.portName || 'Unknown' }}</div>
                    <div class="text-sm text-gray-500 w-1/4">{{ item.origin || item.source || 'Unknown' }}</div>
                    <div class="text-sm text-gray-500 w-1/4">{{ formatDate(item.date) }}</div>
                  </template>
                  <!-- For non-shipping companies, maintain original layout but with better spacing -->
                  <template v-else>
                    <div class="text-sm font-medium text-gray-900 w-1/3">{{ item.lineId || item.displayName || 'Unknown' }}</div>
                    <div class="text-sm text-gray-500 w-1/3">{{ item.origin || item.source || 'Unknown' }}</div>
                    <div class="text-sm text-gray-500 w-1/3">{{ formatDate(item.date) }}</div>
                  </template>
                  <div class="flex justify-end">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Show this when no related items are found -->
            <div v-if="relatedItems && relatedItems.length === 0" class="mb-8">
              <h2 class="text-lg font-medium text-green-700 mb-4">Supply Chain Involvement</h2>
              <p class="text-gray-600">Searching for related items in the supply chain...</p>
            </div>
          </div>
        </div>
        
        <!-- Farm Details Tab -->
        <div v-if="activeTab === 'details' && selectedItem.type === 'farm'" class="tab-content farm-details-tab">
          <div class="bg-white shadow rounded-lg p-6 mt-6">
            <!-- Farm Info Section -->
            <div class="grid grid-cols-2 gap-6 mb-8">
              <div>
                <h3 class="text-md font-medium text-gray-700 mb-3">PIC</h3>
                <p class="text-gray-900">{{ farmDetails.PIC || selectedItem.PIC }}</p>
              </div>
              <div>
                <h3 class="text-md font-medium text-gray-700 mb-3">Region, LGA</h3>
                <p class="text-gray-900">{{ farmDetails.location || 'Unknown' }}</p>
              </div>
              <div>
                <h3 class="text-md font-medium text-gray-700 mb-3">Carbon Reporting Status</h3>
                <p class="text-gray-900">{{ farmDetails.CarbonReportingStatus || 'NGER Scope 1 (Estimated) Tier 2), Scope 1+2' }}</p>
              </div>
              <div>
                <h3 class="text-md font-medium text-gray-700 mb-3">Scope 3 Compliant</h3>
                <p :class="{'text-red-600 font-semibold': farmDetails.Scope3_Compliant === 'No' || farmDetails.Scope3_Compliant === false, 'text-gray-900': farmDetails.Scope3_Compliant !== 'No' && farmDetails.Scope3_Compliant !== false}">
                  {{ farmDetails.Scope3_Compliant === true ? 'Yes' : 'No' }}
                </p>
              </div>
              <div>
                <h3 class="text-md font-medium text-gray-700 mb-3">Products</h3>
                <p class="text-gray-900">{{ farmDetails.Products || 'Prime lamb, wheat, canola, and chickpeas' }}</p>
              </div>
              <div>
                <h3 class="text-md font-medium text-gray-700 mb-3">Certifications</h3>
                <p class="text-gray-900">{{ farmDetails.certification || selectedItem.certification || 'Standard' }}</p>
              </div>
            </div>
            
            <!-- Risks & Summaries Section -->
            <div class="mb-8">
              <h2 class="text-lg font-medium text-green-700 mb-4">Risks & Summaries</h2>
              <p class="text-gray-600 mb-4">No immediate supply chain risks identified for this station.</p>
              
              <!-- Collapsible sections -->
              <div class="rounded-md mb-3" style="background-color: #F5F8F7;">
                <div class="p-3 flex justify-between items-center cursor-pointer">
                  <h3 class="font-medium pl-2">Property Risk Assessment</h3>
                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6.0625L0 1.0625L1.0625 0L5 3.9375L8.9375 0L10 1.0625L5 6.0625Z" fill="#3A895F"/>
                  </svg>
                </div>
              </div>
              
              <div class="rounded-md mb-3" style="background-color: #F5F8F7;">
                <div class="p-3 flex justify-between items-center cursor-pointer">
                  <h3 class="font-medium pl-2">Animal Treatments</h3>
                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6.0625L0 1.0625L1.0625 0L5 3.9375L8.9375 0L10 1.0625L5 6.0625Z" fill="#3A895F"/>
                  </svg>
                </div>
              </div>
              
              <div class="rounded-md mb-3" style="background-color: #F5F8F7;">
                <div class="p-3 flex justify-between items-center cursor-pointer">
                  <h3 class="font-medium pl-2">Stock Foods, Fodder & Crops</h3>
                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6.0625L0 1.0625L1.0625 0L5 3.9375L8.9375 0L10 1.0625L5 6.0625Z" fill="#3A895F"/>
                  </svg>
                </div>
              </div>
              
              <div class="rounded-md mb-3" style="background-color: #F5F8F7;">
                <div class="p-3 flex justify-between items-center cursor-pointer">
                  <h3 class="font-medium pl-2">Biosecurity</h3>
                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6.0625L0 1.0625L1.0625 0L5 3.9375L8.9375 0L10 1.0625L5 6.0625Z" fill="#3A895F"/>
                  </svg>
                </div>
              </div>
              
              <div class="rounded-md mb-3" style="background-color: #F5F8F7;">
                <div class="p-3 flex justify-between items-center cursor-pointer">
                  <h3 class="font-medium pl-2">Records & Traceability</h3>
                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6.0625L0 1.0625L1.0625 0L5 3.9375L8.9375 0L10 1.0625L5 6.0625Z" fill="#3A895F"/>
                  </svg>
                </div>
              </div>
            </div>
            
            <!-- Audits & Reports Section -->
            <div class="mb-8">
              <h2 class="text-lg font-medium text-green-700 mb-4">Audits & Reports</h2>
              
              <!-- Styled table based on the design -->
              <div class="border-t border-gray-200">
                <div class="py-4 border-b border-gray-200 flex justify-between items-center">
                  <div class="text-sm font-medium text-gray-900">AUS-MEAT LPA On-Farm Audit Report #4</div>
                  <div class="flex items-center space-x-12">
                    <div class="text-sm text-gray-500 w-16">Routine</div>
                    <div class="text-sm text-gray-500 w-40">Robert Smith (Ausmeat)</div>
                    <div class="text-sm text-gray-500 w-16">21.08.25</div>
                    <div class="flex justify-end w-8">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="py-4 border-b border-gray-200 flex justify-between items-center">
                  <div class="text-sm font-medium text-gray-900">AUS-MEAT LPA On-Farm Audit Report #3</div>
                  <div class="flex items-center space-x-12">
                    <div class="text-sm text-gray-500 w-16">Routine</div>
                    <div class="text-sm text-gray-500 w-40">Robert Smith (Ausmeat)</div>
                    <div class="text-sm text-gray-500 w-16">16.05.25</div>
                    <div class="flex justify-end w-8">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="py-4 border-b border-gray-200 flex justify-between items-center">
                  <div class="text-sm font-medium text-gray-900">AUS-MEAT LPA On-Farm Audit Report #2</div>
                  <div class="flex items-center space-x-12">
                    <div class="text-sm text-gray-500 w-16">Routine</div>
                    <div class="text-sm text-gray-500 w-40">Jane Lee (Ausmeat)</div>
                    <div class="text-sm text-gray-500 w-16">17.02.25</div>
                    <div class="flex justify-end w-8">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="py-4 border-b border-gray-200 flex justify-between items-center">
                  <div class="text-sm font-medium text-gray-900">AUS-MEAT LPA On-Farm Audit Report #1</div>
                  <div class="flex items-center space-x-12">
                    <div class="text-sm text-gray-500 w-16">Routine</div>
                    <div class="text-sm text-gray-500 w-40">Robert Smith (Ausmeat)</div>
                    <div class="text-sm text-gray-500 w-16">22.11.24</div>
                    <div class="flex justify-end w-8">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Related Section -->
            <div>
              <h2 class="text-lg font-medium text-green-700 mb-4">Related</h2>
              
              <ul class="space-y-0 border-t border-gray-200">
                <li class="flex justify-between items-center py-4 border-b border-gray-200">
                  <a href="#" style="color: #145E37" class="hover:underline">View National Wool Declaration (NWD) records, and Responsible Wool Standard (RWS) or SustainaWOOL accreditation.</a>
                  <div class="flex justify-end w-8">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                    </svg>
                  </div>
                </li>
                <li class="flex justify-between items-center py-4 border-b border-gray-200">
                  <a href="#" style="color: #145E37" class="hover:underline">Investigate the farm's wool supply chain</a>
                  <div class="flex justify-end w-8">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                    </svg>
                  </div>
                </li>
                <li class="flex justify-between items-center py-4 border-b border-gray-200">
                  <a href="#" style="color: #145E37" class="hover:underline">Research the Central West Dubbo region's wool production</a>
                  <div class="flex justify-end w-8">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                    </svg>
                  </div>
                </li>
                <li class="flex justify-between items-center py-4 border-b border-gray-200">
                  <a @click="showPreAuditGuidance" href="javascript:void(0)" style="color: #145E37" class="hover:underline cursor-pointer">Help in preparation for the next audit</a>
                  <div class="flex justify-end w-8">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                    </svg>
                  </div>
                </li>
                <li class="flex justify-between items-center py-4 border-b border-gray-200">
                  <a @click="showAuditFindings" href="javascript:void(0)" style="color: #145E37" class="hover:underline cursor-pointer">Identify medium to major audit findings & Non-conformities for {{ selectedFarm?.name || 'Ironbark Station' }}</a>
                  <div class="flex justify-end w-8">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.47917 8L6.16667 10.3125L7.22917 11.375L10.6042 8L7.22917 4.625L6.16667 5.6875L8.47917 8ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#3A895F"/>
                    </svg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <!-- Data Sources Tab -->
        <div v-if="activeTab === 'data-sources' && selectedItem.type === 'farm'" class="tab-content data-sources-tab">
          <div class="bg-white shadow rounded-lg p-6 mt-6">
            <!-- Atralis Accreditation & Audit Database -->
            <div class="mb-8">
              <div class="flex items-center mb-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <mask id="mask0_382_3431_1" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_382_3431_1)">
                    <path d="M7.0625 14L6 12.9375L9.97917 8.97917H6.52083V7.47917H12.5208V13.4792H11.0208V10.0208L7.0625 14ZM15.5 10V4.5H10V3H17V10H15.5ZM4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V3H4.5V15.5H17V17H4.5Z" fill="#3A895F"/>
                  </g>
                </svg>
                <h3 class="text-lg font-medium text-green-700">1. Atralis Accreditation & Audit Database</h3>
              </div>
              <p class="text-gray-700 mb-3">Central repository for property audit records, accreditation status, and non-conformity history.</p>
              <p class="text-gray-700 mb-2">Data used:</p>
              <ul class="list-disc pl-8 text-gray-700 space-y-1">
                <li>LPA / NVD compliance status</li>
                <li>Last audit date, auditor details, CARs</li>
                <li>Certification type</li>
                <li>Auditor comments and recommendations</li>
              </ul>
            </div>

            <!-- AUS-MEAT Product Integrity Database -->
            <div class="mb-8">
              <div class="flex items-center mb-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <mask id="mask0_382_3431_2" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_382_3431_2)">
                    <path d="M7.0625 14L6 12.9375L9.97917 8.97917H6.52083V7.47917H12.5208V13.4792H11.0208V10.0208L7.0625 14ZM15.5 10V4.5H10V3H17V10H15.5ZM4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V3H4.5V15.5H17V17H4.5Z" fill="#3A895F"/>
                  </g>
                </svg>
                <h3 class="text-lg font-medium text-green-700">2. Atralis Product Integrity (LPA / NLIS Integration) Database</h3>
              </div>
              <p class="text-gray-700 mb-3">Links animal identification (NLIS tags) and movement data with accredited PICs under the AUS-MEAT Integrity System.</p>
              <p class="text-gray-700 mb-2">Data used:</p>
              <ul class="list-disc pl-8 text-gray-700 space-y-1">
                <li>Livestock movements to/from Ironbark Station</li>
                <li>eNVD usage and status</li>
                <li>Traceability risk indicators (incomplete transfers, multiple property contacts)</li>
              </ul>
            </div>

            <!-- Farm Management & Animal Health Records -->
            <div class="mb-8">
              <div class="flex items-center mb-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <mask id="mask0_382_3431_3" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_382_3431_3)">
                    <path d="M7.0625 14L6 12.9375L9.97917 8.97917H6.52083V7.47917H12.5208V13.4792H11.0208V10.0208L7.0625 14ZM15.5 10V4.5H10V3H17V10H15.5ZM4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V3H4.5V15.5H17V17H4.5Z" fill="#3A895F"/>
                  </g>
                </svg>
                <h3 class="text-lg font-medium text-green-700">3. Farm Management & Animal Health Records (Internal Test Database)</h3>
              </div>
              <p class="text-gray-700 mb-3">Locally maintained station database (AgriWebb) recording production, treatment, and welfare data.</p>
              <p class="text-gray-700 mb-2">Data used:</p>
              <ul class="list-disc pl-8 text-gray-700 space-y-1">
                <li>Livestock numbers, classes, lambing %, mortality</li>
                <li>Chemical use logs, vaccinations, feed sources</li>
                <li>Farm map layers (grazing rotations, paddocks)</li>
              </ul>
            </div>

            <!-- Visitor & Biosecurity Log -->
            <div class="mb-8">
              <div class="flex items-center mb-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <mask id="mask0_382_3431_4" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_382_3431_4)">
                    <path d="M7.0625 14L6 12.9375L9.97917 8.97917H6.52083V7.47917H12.5208V13.4792H11.0208V10.0208L7.0625 14ZM15.5 10V4.5H10V3H17V10H15.5ZM4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V3H4.5V15.5H17V17H4.5Z" fill="#3A895F"/>
                  </g>
                </svg>
                <h3 class="text-lg font-medium text-green-700">4. Visitor & Biosecurity Log (AUS-MEAT Biosecurity Compliance Register / Local Log)</h3>
              </div>
              <p class="text-gray-700 mb-3">Records all on-farm visits to ensure traceability of people, vehicles, and equipment.</p>
              <p class="text-gray-700 mb-2">Data used:</p>
              <ul class="list-disc pl-8 text-gray-700 space-y-1">
                <li>Vet, contractor, inspector, transporter entries</li>
                <li>Disinfection, PPE use, and compliance</li>
                <li>Links to risk scores (frequency × proximity × recent incidents)</li>
              </ul>
            </div>
             <!-- Farm Management & Animal Health Records -->
            <div class="mb-8">
              <div class="flex items-center mb-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <mask id="mask0_382_3431_3" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_382_3431_3)">
                    <path d="M7.0625 14L6 12.9375L9.97917 8.97917H6.52083V7.47917H12.5208V13.4792H11.0208V10.0208L7.0625 14ZM15.5 10V4.5H10V3H17V10H15.5ZM4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V3H4.5V15.5H17V17H4.5Z" fill="#3A895F"/>
                  </g>
                </svg>
                <h3 class="text-lg font-medium text-green-700">5. Publicly available information & records</h3>
              </div>
              <p class="text-gray-700 mb-3">Location, ownership and certification data.</p>
            </div>


          </div>
        </div>
        
        <!-- Wool Line Details Tab -->
        <div v-if="activeTab === 'list-view' && selectedItem.type !== 'farm'" class="tab-content list-view-tab">
          <div class="bg-white shadow rounded-lg p-6 mt-6">
            <h2 class="text-lg font-medium text-gray-900 mb-4">Item Details</h2>
            
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <!-- Key Metrics -->
              <div class="metric-card p-4 rounded-lg" style="background-color: #F5F8F7">
                <h3 class="text-sm font-medium mb-2" style="color: #3A895F">Processing Time</h3>
                <p class="text-2xl font-bold text-gray-900">{{ itemDetails.total_days }} days</p>
                <p class="text-xs text-gray-700 mt-1">From farm to final product</p>
              </div>
              
              <div class="metric-card p-4 rounded-lg" style="background-color: #F5F8F7">
                <h3 class="text-sm font-medium mb-2" style="color: #3A895F">Wool Weight</h3>
                <p class="text-2xl font-bold text-gray-900">{{ itemDetails.weight_kg }} kg</p>
                <p class="text-xs text-gray-700 mt-1">Total greasy wool weight</p>
              </div>
              
              <div class="metric-card p-4 rounded-lg" style="background-color: #F5F8F7">
                <h3 class="text-sm font-medium mb-2" style="color: #3A895F">Micron</h3>
                <p class="text-2xl font-bold text-gray-900">{{ itemDetails.micron_um }} μm</p>
                <p class="text-xs text-gray-700 mt-1">Average fiber diameter</p>
              </div>
              
              <div class="metric-card p-4 rounded-lg" style="background-color: #F5F8F7">
                <h3 class="text-sm font-medium mb-2" style="color: #3A895F">Price</h3>
                <p class="text-2xl font-bold text-gray-900">{{ itemDetails.price_cents_kg }} ¢/kg</p>
                <p class="text-xs text-gray-700 mt-1">Auction price (greasy)</p>
              </div>
              
              <div class="metric-card p-4 rounded-lg" style="background-color: #F5F8F7">
                <h3 class="text-sm font-medium mb-2" style="color: #3A895F">Sheep Count</h3>
                <p class="text-2xl font-bold text-gray-900">{{ itemDetails.sheep_count }}</p>
                <p class="text-xs text-gray-700 mt-1">Animals in source mob</p>
              </div>
              
              <div class="metric-card p-4 rounded-lg" style="background-color: #F5F8F7">
                <h3 class="text-sm font-medium mb-2" style="color: #3A895F">Fabric Rolls</h3>
                <p class="text-2xl font-bold text-gray-900">{{ itemDetails.fabric_rolls }}</p>
                <p class="text-xs text-gray-700 mt-1">Final product output</p>
              </div>
            </div>
            
            <!-- Additional Details -->
            <div class="mt-8">
              <h3 class="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
              
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 class="font-medium text-gray-800 mb-2">Wool Description</h4>
                  <p class="text-gray-600">{{ itemDetails.description }}</p>
                </div>
                
                <div>
                  <h4 class="font-medium text-gray-800 mb-2">Classer Information</h4>
                  <p class="text-gray-600">{{ itemDetails.classer }}</p>
                  <p class="text-gray-600 mt-1">{{ itemDetails.bales_info }}</p>
                </div>
              </div>
            </div>
            
            <!-- Farm Details -->
            <div class="mt-8" v-if="farmDetails.PIC">
              <h3 class="text-lg font-medium text-gray-900 mb-4">Farm Details</h3>
              
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <h4 class="text-sm font-medium text-gray-500">PIC</h4>
                  <p class="text-gray-900">{{ farmDetails.PIC }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Location</h4>
                  <p class="text-gray-900">{{ farmDetails.location }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Certification</h4>
                  <p class="text-gray-900">{{ farmDetails.certification }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Mob ID</h4>
                  <p class="text-gray-900">{{ farmDetails.mob_id }}</p>
                </div>
              </div>
            </div>
            
            <!-- Factory Details -->
            <div class="mt-8" v-if="factoryDetails.name">
              <h3 class="text-lg font-medium text-gray-900 mb-4">Factory Details</h3>
              
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Factory Name</h4>
                  <p class="text-gray-900">{{ factoryDetails.name }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Factory ID</h4>
                  <p class="text-gray-900">{{ factoryDetails.factory_id }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Country</h4>
                  <p class="text-gray-900">{{ factoryDetails.country }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Certification</h4>
                  <p class="text-gray-900">{{ factoryDetails.certification }}</p>
                </div>
              </div>
            </div>
            
            <!-- Export Details -->
            <div class="mt-8" v-if="exportDetails">
              <h3 class="text-lg font-medium text-gray-900 mb-4">Export Details</h3>
              
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Consignment ID</h4>
                  <p class="text-gray-900">{{ exportDetails.consignment_id }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Export Permit</h4>
                  <p class="text-gray-900">{{ exportDetails.permit }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Port</h4>
                  <p class="text-gray-900">{{ exportDetails.port }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Containers</h4>
                  <p class="text-gray-900">{{ exportDetails.containers }}</p>
                </div>
                
                <div>
                  <h4 class="text-sm font-medium text-gray-500">Freight Company</h4>
                  <p class="text-gray-900">{{ exportDetails.freight_company }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-else-if="activeTab === 'supply-chain'" class="tab-content supply-chain-detail-tab">
          <div class="main-content-area">
            <SupplyChainView 
              :selectedItem="selectedItem"
              :farmDetails="farmDetails"
              :factoryDetails="factoryDetails"
              :exportDetails="exportDetails"
              :selectedResult="selectedItem"
            />
          </div>
        </div>
        
        <div v-else-if="activeTab === 'connections-graph'" class="tab-content connections-detail-tab">
          <div class="main-content-area">
            <ConnectionsGraphView 
              :searchResult="searchResults" 
              :selectedItem="selectedItem"
              :selectedCard="selectedCard"
              :auctionDetails="auctionDetails"
              :selectedResultIndex="0"
            />
          </div>
        </div>
        
        <div v-else-if="activeTab === 'files'" class="tab-content files-detail-tab">
          <div class="main-content-area">
            <FilesView :searchResult="{ results: [selectedItem] }" />
          </div>
        </div>
      </div>
      </div>
      
      <!-- Loading indicator moved inline with the toggle -->

      <div v-if="viewMode === 'search' && hasSearched && !loading && (!searchResults || searchResults.count === 0)" class="no-results">
        <p>No results found for "{{ searchQuery }}"</p>
        <p>Try adjusting your search terms or selecting a different type.</p>
      </div>
    </div>

    <!-- AI Insights Modal -->
    <ai-insights-modal
      :is-open="showAIInsights"
      :entity-type="aiInsightsEntityType"
      :entity-name="aiInsightsEntityName"
      :entity-data="aiInsightsEntityData"
      :notifications="entityNotifications"
      @close="showAIInsights = false"
    />
  </div>
</template>

<script>
import AIAssistantPanel from './AIAssistantPanel.vue'
import SupplyChainView from './SupplyChainView.vue'
import ConnectionsGraphView from './ConnectionsGraphView.vue'
import FilesView from './FilesView.vue'
import PreAuditGuidance from './PreAuditGuidance.vue';
import AuditFindings from './AuditFindings.vue';
import AnalyticsView from './AnalyticsView.vue';
import NotificationBanner from './NotificationBanner.vue';
import NotificationService from '../services/NotificationService.js';
import Fuse from 'fuse.js';
import ConnectionsGraph from './ConnectionsGraph.vue';
import IndustrySelector from './IndustrySelector.vue';
import { marked } from 'marked';
import { Chart, registerables } from 'chart.js';

// Register Chart.js components
Chart.register(...registerables);

// Configure marked for safe rendering
marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  mangle: false
});

export default {
  components: {
    SupplyChainView,
    ConnectionsGraphView,
    FilesView,
    NotificationBanner,
    AIAssistantPanel,
    PreAuditGuidance,
    AuditFindings,
    ConnectionsGraph,
    AnalyticsView,
    IndustrySelector
  },
  
  data() {
    return {
      processedAuditReport: null,
      searchQuery: '',
      deepSearchEnabled: false,
      loading: false,
      hasSearched: false,
      showSuggestions: false,
      suggestions: [],
      suggestionDebounceTimer: null,
      searchResults: null,
      entityNotifications: [],
      sortOption: 'relevance',
      showSortDropdown: false,
      selectedItem: null,
      itemDetails: {},
      viewMode: 'search', // 'search', 'detail'
      activeTab: 'overview',
      showSidebar: true,
      selectedIndustry: null, // Track the currently selected industry
      isDataIngestionPage: window.location.pathname === '/data-ingestion',
      isDataSourcesPage: window.location.pathname === '/data-sources',
      isAutomationsPage: window.location.pathname === '/automations',
      isInsightsPage: window.location.pathname === '/insights',
      isDomainGraphPage: window.location.pathname === '/domain-graph',
      isChatPage: window.location.pathname === '/chat',
      showChatSidebar: false,
      isMobileSidebarOpen: false,
      isMobileAIPanelOpen: false,
      chatMessages: [],
      chatInput: '',
      chatLoading: false,
      n8nWebhookUrl: import.meta.env.VITE_N8N_WEBHOOK_URL || '',
      customChatMessages: [],
      customChatInput: '',
      customChatLoading: false,
      loadingMessages: [
        'Thinking ...',  
        'Thinking longer for better answer ...',
        'Analyzing the details ...' ,
        'Reviewing the information ...',
        'Processing your request ...',
        'Formulating the best response ...',
        'Verifying relevant data ...'
      ],
      currentLoadingMessageIndex: 0,
      loadingMessageInterval: null,
      relatedItems: [], // For storing related supply chain items
      connectionData: [],
      recentItems: [], // Track recently viewed items in this session
      loadingConnections: false,
      itemDetails: {
        total_days: null,
        weight_kg: null,
        micron_um: null,
        price_cents_kg: null,
        sheep_count: null,
        fabric_rolls: null,
        description: null,
        classer: null,
        bales_info: null
      },
      farmDetails: {
        location: null,
        PIC: null,
        certification: null,
        mob_id: null
      },
      exportDetails: null,
      factoryDetails: {
        name: null,
        factory_id: null,
        country: null,
        certification: null
      },
      auctionDetails: {
        sale_date: null,
        broker: null,
        lot_number: null,
        mulesing_status: null
      },
      selectedCard: null,
      filterOptions: {
        compliance: false,
        sustainability: false,
        regulatory: false,
        risks: false
      },
      showAIInsights: false,
      aiInsightsEntityType: '',
      aiInsightsEntityName: '',
      aiInsightsEntityData: {}
    }
  },
  
  computed: {
    greeting() {
      const hour = new Date().getHours();
      const names = ['Robbie', 'Tim', 'Arthur', 'Patrick', 'Paul', 'Damien'];
      const randomName = names[Math.floor(Math.random() * names.length)];
      
      let timeGreeting = '';
      if (hour < 12) {
        timeGreeting = 'Good morning';
      } else if (hour < 18) {
        timeGreeting = 'Good afternoon';
      } else {
        timeGreeting = 'Good evening';
      }
      
      return `${timeGreeting}, ${randomName}`;
    },
    
    currentLoadingMessage() {
      return this.loadingMessages[this.currentLoadingMessageIndex];
    },
    
    showingPreAuditGuidance() {
      return this.viewMode === 'pre-audit-guidance';
    },
    
    showingAuditFindings() {
      return this.viewMode === 'audit-findings';
    },
    
    selectedFarm() {
      // Return the selected farm based on the selectedItem
      if (this.selectedItem && (this.selectedItem.type === 'farm' || (this.selectedItem.id && this.selectedItem.id.toString().startsWith('farm-')))) {
        return this.selectedItem;
      }
      return { name: 'Ironbark Station' };
    },
    
    entityFields() {
      // Return all fields of the selected entity that have values
      if (!this.selectedItem) return {};
      
      // Create a copy of the selectedItem object
      const fields = {...this.selectedItem};
      
      // Return only fields that have values
      return Object.keys(fields).reduce((result, key) => {
        if (fields[key] !== null && fields[key] !== undefined && fields[key] !== '') {
          result[key] = fields[key];
        }
        return result;
      }, {});
    },
    
    groupedResults() {
      if (!this.searchResults || !this.searchResults.results) return [];
      
      // Group results by category (industry-specific products, Farm, or Commercial Entity)
      const groups = [];
      
      console.log('Raw search results in groupedResults:', this.searchResults.results);
      console.log('Current industry:', this.selectedIndustry);
      
      // Determine current industry mode
      const currentIndustry = this.selectedIndustry?.id || 'wool';
      
      // Industry-specific product group configuration
      const industryProductConfig = {
        wool: {
          category: 'Wool Line ID',
          type: 'wool_line',
          filter: (item) => item.type === 'wool_line' || (item.code && item.code.match(/^[A-Z]+-\d+-\d+$/))
        },
        beef: {
          category: 'NLIS Device ID',
          type: 'nlis_device',
          filter: (item) => item.type === 'nlis_device' || item.type === 'beef_lot'
        },
        dairy: {
          category: 'Dairy Batch ID',
          type: 'dairy_batch',
          filter: (item) => item.type === 'dairy_batch'
        },
        grain: {
          category: 'Grain Batch ID',
          type: 'grain_batch',
          filter: (item) => item.type === 'grain_batch'
        },
        seafood: {
          category: 'Catch ID',
          type: 'catch',
          filter: (item) => item.type === 'catch' || item.type === 'seafood_batch'
        },
        feedlot: {
          category: 'Lot ID',
          type: 'feedlot_lot',
          filter: (item) => item.type === 'feedlot_lot'
        },
        pigs: {
          category: 'Pig Batch ID',
          type: 'pig_batch',
          filter: (item) => item.type === 'pig_batch'
        },
        oysters: {
          category: 'Oyster Lease ID',
          type: 'oyster_lease',
          filter: (item) => item.type === 'oyster_lease' || item.type === 'oyster_batch'
        },
        poultry: {
          category: 'Flock ID',
          type: 'poultry_flock',
          filter: (item) => item.type === 'poultry_flock' || item.type === 'poultry_batch'
        }
      };
      
      // Get the product configuration for current industry
      const productConfig = industryProductConfig[currentIndustry];
      
      // Create industry-specific product group
      let productGroup = null;
      if (productConfig) {
        productGroup = {
          category: productConfig.category,
          items: this.searchResults.results.filter(item => {
            const isProduct = productConfig.filter(item);
            
            // Ensure items have the correct type
            if (isProduct && item.type !== productConfig.type) {
              item.type = productConfig.type;
            }
            
            console.log(`Item ${item.id || item.name}: is${productConfig.category}=${isProduct}`, item);
            return isProduct;
          })
        };
      }
      
      // Find farm entries
      const farmGroup = {
        category: 'Farm',
        items: this.searchResults.results.filter(item => {
          // Check if the item is explicitly marked as a farm or has a farm ID
          const isFarm = item.type === 'farm' || (item.id && item.id.toString().startsWith('farm-'));
          console.log(`Item ${item.id || item.name}: isFarm=${isFarm}`, item);
          return isFarm;
        })
      };
      
      // Find commercial entities
      const commercialEntityTypes = [
        'classer', 'testing_lab', 'broker', 'auction_house', 
        'shipping_company', 'factory', 'brand', 'certification_body', 'government_agency'
      ];
      
      console.log('Commercial entity types:', commercialEntityTypes);
      console.log('All search results:', this.searchResults.results);
      
      // Check each result for its type
      this.searchResults.results.forEach(item => {
        console.log(`Item ${item.id || item.name} has type: ${item.type}`);
      });
      
      const commercialGroup = {
        category: 'Commercial Entities',
        items: this.searchResults.results.filter(item => {
          const isCommercial = commercialEntityTypes.includes(item.type) || 
            (item.id && commercialEntityTypes.some(type => item.id.toString().startsWith(`${type}-`)));
          console.log(`Item ${item.id || item.name}: isCommercial=${isCommercial}`, item);
          return isCommercial;
        })
      };
      
      console.log('Commercial group items count:', commercialGroup.items.length);
      
      console.log('Product Group:', productGroup);
      console.log('Farm Group:', farmGroup);
      console.log('Commercial Group:', commercialGroup);
      
      // Add groups in the desired order: Commercial entities, farms, industry-specific products
      if (commercialGroup.items.length > 0) groups.push(commercialGroup);
      if (farmGroup.items.length > 0) groups.push(farmGroup);
      if (productGroup && productGroup.items.length > 0) groups.push(productGroup);
      
      return groups;
    }
  },
  
  mounted() {
    // Load recent items from sessionStorage on component mount
    const savedRecentItems = sessionStorage.getItem('agricore_recent_items');
    console.log('Loading recent items from sessionStorage:', savedRecentItems);
    if (savedRecentItems) {
      try {
        const items = JSON.parse(savedRecentItems);
        console.log('Parsed recent items:', items);
        // Use splice to trigger reactivity
        this.recentItems.splice(0, this.recentItems.length, ...items);
        console.log('Loaded recent items into component:', this.recentItems);
      } catch (e) {
        console.error('Error loading recent items from sessionStorage:', e);
        this.recentItems = [];
      }
    }
    console.log('Component mounted, recentItems:', this.recentItems);
    
    // Check for pending chat message from deep research
    if (this.isChatPage) {
      const pendingMessage = sessionStorage.getItem('pendingChatMessage');
      if (pendingMessage) {
        // Set the message in the input
        this.customChatInput = pendingMessage;
        // Clear from session storage
        sessionStorage.removeItem('pendingChatMessage');
        // Auto-submit after a short delay to ensure component is ready
        this.$nextTick(() => {
          setTimeout(() => {
            this.handleCustomChatSubmit();
          }, 100);
        });
      }
    }
  },
  
  beforeUnmount() {
    // Clean up loading message interval when component is destroyed
    this.stopLoadingMessageCycle();
  },
  
  methods: {
    handleSearchInput() {
      // Clear previous timer
      if (this.suggestionDebounceTimer) {
        clearTimeout(this.suggestionDebounceTimer);
      }
      
      // Don't show suggestions if query is too short
      if (this.searchQuery.length < 2) {
        this.suggestions = [];
        this.showSuggestions = false;
        return;
      }
      
      // Debounce the API call
      this.suggestionDebounceTimer = setTimeout(() => {
        this.fetchSuggestions();
      }, 300);
    },
    
    async fetchSuggestions() {
      const query = this.searchQuery.trim();
      if (!query || query.length < 2) {
        this.suggestions = [];
        return;
      }
      
      try {
        // Fetch suggestions from multiple sources using Supabase client
        const suggestions = [];
        
        // 1. Search farms
        const { data: farms, error: farmError } = await this.$supabase
          .from('farm_profiles')
          .select('*')
          .or(`FarmName.ilike.%${query}%,PIC.ilike.%${query}%`)
          .limit(5);
        
        if (!farmError && farms) {
          farms.forEach(farm => {
            suggestions.push({
              type: 'farm',
              name: farm.FarmName,
              description: `${farm.Region || ''} ${farm.PIC ? '• PIC: ' + farm.PIC : ''}`.trim(),
              data: farm
            });
          });
        }
        
        // 2. Search wool lines
        const { data: woolLines, error: woolError } = await this.$supabase
          .from('trace_index')
          .select('*')
          .ilike('LineID', `%${query}%`)
          .limit(5);
        
        if (!woolError && woolLines) {
          woolLines.forEach(line => {
            suggestions.push({
              type: 'wool_line',
              name: line.LineID,
              description: `${line.FarmName ? 'From ' + line.FarmName : ''} ${line.Micron_um ? '• ' + line.Micron_um + 'μm' : ''}`.trim(),
              data: line
            });
          });
        }
        
        // 3. Search factories
        const { data: factories, error: factoryError } = await this.$supabase
          .from('factories')
          .select('*')
          .or(`Name.ilike.%${query}%,FactoryID.ilike.%${query}%`)
          .limit(3);
        
        if (!factoryError && factories) {
          factories.forEach(factory => {
            suggestions.push({
              type: 'factory',
              name: factory.Name,
              description: `${factory.Country || ''} ${factory.FactoryID ? '• ID: ' + factory.FactoryID : ''}`.trim(),
              data: factory
            });
          });
        }
        
        this.suggestions = suggestions;
        this.showSuggestions = suggestions.length > 0;
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        this.suggestions = [];
      }
    },
    
    selectSuggestion(suggestion) {
      // Set the search query to the selected suggestion
      this.searchQuery = suggestion.name;
      this.showSuggestions = false;
      
      // Perform the search immediately
      this.performSearch();
    },
    
    hideSuggestionsDelayed() {
      // Delay hiding to allow click events on suggestions to fire
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    
    formatSuggestionType(type) {
      const typeMap = {
        'farm': 'Farm',
        'wool_line': 'Wool Line',
        'factory': 'Factory',
        'export': 'Export',
        'consignment': 'Consignment'
      };
      return typeMap[type] || type;
    },
    
    async loadEntityNotifications(item) {
      try {
        // First, generate new notifications based on current data
        await NotificationService.generateNotifications(item.type, item);
        
        // Then fetch all active notifications for this entity
        const entityId = this.getEntityId(item);
        console.log('Loading notifications for:', { type: item.type, entityId, item });
        
        if (entityId) {
          this.entityNotifications = await NotificationService.getNotificationsForEntity(item.type, entityId);
          console.log('Loaded notifications:', this.entityNotifications);
        } else {
          console.log('No entity ID found for item:', item);
          this.entityNotifications = [];
        }
      } catch (error) {
        console.error('Error loading entity notifications:', error);
        this.entityNotifications = [];
      }
    },
    
    getEntityId(item) {
      // Extract the appropriate ID based on entity type
      switch (item.type) {
        case 'farm':
          return item.PIC || item.pic;
        case 'wool_line':
          return item.LineID || item.lineId || item.code;
        case 'consignment':
        case 'export':
          return item.ConsignmentID || item.code;
        case 'factory':
          return item.FactoryID || item.code;
        case 'mob':
          return item.MobID || item.code;
        default:
          return item.id || item.code;
      }
    },
    
    handleNotificationDismissed(notificationId) {
      // Remove the dismissed notification from the list
      this.entityNotifications = this.entityNotifications.filter(n => n.id !== notificationId);
    },
    
    openAIInsights() {
      // Set entity data based on current selected item
      if (this.selectedItem) {
        this.aiInsightsEntityType = this.selectedItem.type === 'farm' ? 'Farm' : 
                                    this.selectedItem.type === 'wool_line' ? 'Wool Line' :
                                    this.selectedItem.type === 'factory' ? 'Factory' :
                                    this.selectedItem.type === 'export' ? 'Consignment' :
                                    this.selectedItem.type;
        this.aiInsightsEntityName = this.selectedItem.name || this.selectedItem.code || 'Unknown';
        this.aiInsightsEntityData = {
          ...this.selectedItem,
          farmDetails: this.farmDetails,
          factoryDetails: this.factoryDetails,
          exportDetails: this.exportDetails,
          auctionDetails: this.auctionDetails
        };
        this.showAIInsights = true;
      }
    },
    
    closeAIInsights() {
      this.showAIInsights = false;
    },
    
    getFarmImage(imageNumber) {
      // Get the farm type from Industry field (wool, beef, dairy, etc), not the 'type' field which is just 'farm'
      let farmType = this.selectedItem?.Industry || this.farmDetails?.Industry || this.selectedItem?.industry || 'wool';
      
      // Ensure farmType is lowercase
      farmType = farmType ? farmType.toLowerCase() : 'wool';
      
      // Add cache busting parameter to force reload of updated images
      const timestamp = new Date().getTime();
      
      console.log('Farm image requested:', farmType, imageNumber, 'from selectedItem:', this.selectedItem);
      
      // Return the appropriate image path based on farm type
      return `/images/farms/${farmType}-${imageNumber}.jpg?v=${timestamp}`;
    },
    
    getFarmImageAlt(imageNumber) {
      const farmType = this.selectedItem?.Industry || this.farmDetails?.Industry || this.selectedItem?.industry || 'wool';
      
      const altTexts = {
        wool: ['Farm aerial view', 'Sheep herd', 'Farm operations'],
        beef: ['Cattle grazing', 'Beef herd', 'Ranch operations'],
        dairy: ['Dairy farm view', 'Dairy cows', 'Milking operations'],
        grain: ['Grain fields', 'Harvest operations', 'Grain storage'],
        seafood: ['Fishing operations', 'Seafood catch', 'Processing facility'],
        feedlot: ['Feedlot view', 'Cattle feeding', 'Feed operations'],
        pigs: ['Pig farm view', 'Pig herd', 'Farm facilities'],
        oysters: ['Oyster lease', 'Oyster farming', 'Harvest operations']
      };
      
      return altTexts[farmType]?.[imageNumber - 1] || `Farm image ${imageNumber}`;
    },
    
    handleIndustryChange(industry) {
      console.log('Industry changed to:', industry);
      this.selectedIndustry = industry;
      
      // Clear current search results and selected item when switching industries
      this.searchResults = null;
      this.selectedItem = null;
      this.hasSearched = false;
      this.searchQuery = '';
      
      // You can add industry-specific logic here
      // For example, updating API endpoints, table names, or query filters
    },
    
    isCommercialEntity(type) {
      const commercialEntityTypes = [
        'classer', 'testing_lab', 'broker', 'auction_house', 
        'shipping_company', 'factory', 'brand', 'certification_body', 'government_agency'
      ];
      return commercialEntityTypes.includes(type);
    },

    formatEntityType(type) {
      // Convert snake_case to Title Case
      return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    
    formatFieldName(key) {
      // Convert camelCase or snake_case to Title Case with spaces
      // First handle camelCase
      const spacedKey = key.replace(/([A-Z])/g, ' $1').trim();
      // Then handle snake_case
      return spacedKey
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      
      // Check if it's already in a short format
      if (dateString.length <= 10) return dateString;
      
      try {
        const date = new Date(dateString);
        
        // Check if the date is valid
        if (isNaN(date.getTime())) {
          console.log('Invalid date:', dateString);
          return 'N/A';
        }
        
        return date.toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit', year: '2-digit' });
      } catch (e) {
        console.log('Error formatting date:', e);
        return 'N/A';
      }
    },
    
    navigateToItem(item) {
      console.log('Navigating to item:', item);
      
      // Save the current item in case we want to go back
      const previousItem = this.selectedItem;
      
      // Scroll to top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Fetch the related item details
      if (item.type === 'wool_line') {
        // For wool lines, we need to fetch the details from the trace_index table
        this.fetchWoolLineDetails(item);
      } else {
        // For other types, we can just show the item directly
        this.showDetails(item);
      }
    },
    
    navigateToNode(node) {
      console.log('Navigating to node from connections graph:', node);
      
      // Reset connections data to force reload when returning to connections tab
      this.connectionData = [];
      
      // Create a proper item object from the node
      const item = {
        id: node.id,
        name: node.name,
        type: node.type,
        code: node.code,
        lineId: node.lineId,
        ...node
      };
      
      // Navigate to the item
      this.navigateToItem(item);
    },
    
    async fetchWoolLineDetails(item) {
      try {
        // Show loading state
        this.loading = true;
        
        // Fetch wool line details from trace_index
        const response = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?LineID=eq.${item.lineId}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          console.log('Wool line details:', data);
          
          if (data && data.length > 0) {
            // Create a wool line item from the trace_index data
            const woolLine = {
              id: `wool-line-${data[0].LineID}`,
              type: 'wool_line',
              name: data[0].LineID,
              code: data[0].LineID,
              description: `Wool line from ${data[0].FarmName || 'Unknown Farm'}`,
              origin_farm: data[0].FarmName,
              destination: data[0].FactoryID ? `Factory ${data[0].FactoryID}` : 'Unknown',
              updated_at: data[0].SaleDateTime || data[0].ShearingDate || new Date().toISOString(),
              // Add other relevant fields
              PIC: data[0].PIC,
              FarmName: data[0].FarmName,
              ClasserID: data[0].ClasserID,
              ClasserName: data[0].ClasserName,
              BrokerCode: data[0].BrokerCode,
              SaleDateTime: data[0].SaleDateTime,
              TestCertID: data[0].TestCertID,
              Micron_um: data[0].Micron_um,
              Yield_pct: data[0].Yield_pct
            };
            
            // Show the wool line details
            this.showDetails(woolLine);
          } else {
            console.error('No wool line found with LineID:', item.lineId);
            // Show a message to the user
            alert(`No details found for wool line ${item.lineId}`);
          }
        } else {
          console.error('Error fetching wool line details:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching wool line details:', error);
      } finally {
        this.loading = false;
      }
    },
    
    async performSearch() {
      // If deep research is enabled, redirect to chat page with the query
      if (this.deepSearchEnabled) {
        // Navigate to chat page
        window.location.href = '/chat';
        
        // Store the search query to be submitted on the chat page
        sessionStorage.setItem('pendingChatMessage', this.searchQuery);
        return;
      }
      
      this.loading = true
      this.hasSearched = true
      
      // Scroll to top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Initialize results array to store all search results
      let allResults = [];
      let resultCount = 0;
      
      try {
        // First, make the original API call to get wool line data
        const response = await fetch(`/api/search`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          },
          body: JSON.stringify({
            query: this.searchQuery,
            type: this.searchType
          })
        })
        
        const data = await response.json()
        
        if (!response.ok) {
          console.error('Search error:', data.error)
          this.searchResults = { count: 0, results: [] }
          return
        }
        
        // Add wool line results to allResults
        if (data && data.results) {
          allResults = [...allResults, ...data.results];
          resultCount += data.results.length;
          console.log('Added wool line results:', data.results.length);
        }
        
        // Use the backend controller to fetch farm data
        // This avoids CORS issues by proxying the request through our backend
        try {
          // Make a separate API call to search for farms
          const farmResponse = await fetch(`/api/search/farms`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
            },
            body: JSON.stringify({
              query: this.searchQuery,
              industry: this.selectedIndustry?.id || 'wool'
            })
          });
          
          if (farmResponse.ok) {
            const farmData = await farmResponse.json();
            console.log('Farm data from backend:', farmData);
            
            // If the backend returns farm data, add it to allResults
            if (farmData && farmData.results && farmData.results.length > 0) {
              // Add farm results to allResults
              allResults = [...allResults, ...farmData.results];
              resultCount += farmData.results.length;
              console.log('Added farm results:', farmData.results.length);
            } else {
              // Use mock farm data that matches the search query
              if (this.searchQuery && this.searchQuery.trim() !== '') {
                const searchTerm = this.searchQuery.trim().toLowerCase();
                
                // Sample farm data
                const allFarmEntries = [
                  {
                    id: 'farm-NSW123456',
                    type: 'farm',
                    name: 'Kookaburra Plains',
                    PIC: 'NSW123456',
                    region: 'New South Wales',
                    LGA: 'Armidale',
                    certification: 'SustainaWool Certified',
                    origin_farm: 'Kookaburra Plains',
                    destination: 'Sydney Wool Exchange',
                    updated_at: new Date().toISOString().split('T')[0],
                    OwnerName: 'Ash & Mia Robertson'
                  },
                  {
                    id: 'farm-VIC789012',
                    type: 'farm',
                    name: 'Merino Heights',
                    PIC: 'VIC789012',
                    region: 'Victoria',
                    LGA: 'Western District',
                    certification: 'RWS Certified',
                    origin_farm: 'Merino Heights',
                    destination: 'Melbourne Wool Center',
                    updated_at: new Date().toISOString().split('T')[0],
                    OwnerName: 'James & Sarah Wilson'
                  },
                  {
                    id: 'farm-SA456789',
                    type: 'farm',
                    name: 'Woolly Downs',
                    PIC: 'SA456789',
                    region: 'South Australia',
                    LGA: 'Flinders Ranges',
                    origin_farm: 'Woolly Downs',
                    destination: 'Adelaide Processing',
                    updated_at: new Date().toISOString().split('T')[0],
                    OwnerName: 'Thomas Anderson'
                  },
                  {
                    id: 'farm-QLD234567',
                    type: 'farm',
                    name: 'Queensland Merino',
                    PIC: 'QLD234567',
                    region: 'Queensland',
                    LGA: 'Darling Downs',
                    certification: 'Organic Certified',
                    origin_farm: 'Queensland Merino',
                    destination: 'Brisbane Processing',
                    updated_at: new Date().toISOString().split('T')[0],
                    OwnerName: 'Emma & Michael Johnson'
                  }
                ];
                
                // Filter farm entries based on search term
                const farmEntries = searchTerm.toLowerCase().includes('ko') ? 
                  allFarmEntries.filter(farm => farm.name === 'Kookaburra Plains') : 
                  allFarmEntries.filter(farm => 
                    farm.name.toLowerCase().includes(searchTerm) || 
                    farm.region.toLowerCase().includes(searchTerm) ||
                    farm.PIC.toLowerCase().includes(searchTerm) ||
                    (farm.certification && farm.certification.toLowerCase().includes(searchTerm))
                  );
                
                console.log('Using mock farm entries:', farmEntries);
                console.log('Farm entries have OwnerName?', farmEntries.map(f => !!f.OwnerName));
                
                // Add mock farm entries to allResults
                allResults = [...allResults, ...farmEntries];
                resultCount += farmEntries.length;
                console.log('Added mock farm results:', farmEntries.length);
              }
            }
          }
        } catch (farmError) {
          console.error('Error fetching farm data from backend:', farmError);
        }
        
        // Add commercial entities to search results
        try {
          // Make an API call to fetch commercial entities from Supabase
          console.log('Searching for commercial entities with query:', this.searchQuery);
          
          let commercialEntities = [];
          
          // Always fetch commercial entities, whether search is empty or not
          const searchTerm = this.searchQuery ? this.searchQuery.trim().toLowerCase() : '';
          console.log('Searching for commercial entities with search term:', searchTerm);
          
          // Make a request to fetch commercial entities from Supabase
          try {
            const commercialResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities`, {
              method: 'GET',
              headers: {
                'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
              }
            });
            
            if (commercialResponse.ok) {
              const commercialData = await commercialResponse.json();
              console.log('Commercial entity data from Supabase:', commercialData);
              
              // If search is empty, include all entities, otherwise filter based on search term
              if (searchTerm === '') {
                commercialEntities = commercialData;
                console.log('Empty search - including all commercial entities:', commercialEntities.length);
              } else {
                commercialEntities = commercialData.filter(entity => {
                  const nameMatch = entity.name?.toLowerCase().includes(searchTerm);
                  const descMatch = entity.description?.toLowerCase().includes(searchTerm);
                  const typeMatch = entity.type?.toLowerCase().includes(searchTerm);
                  const codeMatch = entity.code?.toLowerCase().includes(searchTerm);
                  
                  return nameMatch || descMatch || typeMatch || codeMatch;
                });
              }
              
              console.log('Filtered commercial entities from Supabase:', commercialEntities);
            } else {
              console.log('Error fetching from Supabase, falling back to mock data');
              throw new Error('Failed to fetch from Supabase');
            }
          } catch (supabaseError) {
            console.error('Supabase fetch error:', supabaseError);
            console.log('Falling back to mock commercial entities');
            
            // Sample commercial entity data as fallback
            const allCommercialEntities = [
              // Classers
              {
                id: 'classer-12345',
                type: 'classer',
                name: 'Robert Johnson',
                code: 'AWEX-12345',
                description: 'Senior wool classer with 20+ years experience specializing in fine merino classification. Robert has worked with over 50 farms across New South Wales and Victoria, ensuring consistent quality standards and optimal lot preparation.',
                location: 'New South Wales',
                certification: 'AWEX Certified Master Classer',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'robert.johnson@example.com | +61 2 9123 4567',
                ClasserID: 'AWEX-12345',
                AWEXRegistration: '2001-05-15',
                active_since: '2001'
              },
              {
                id: 'classer-23456',
                type: 'classer',
                name: 'Sarah Williams',
                code: 'AWEX-23456',
                description: 'Experienced wool classer specializing in superfine wool. Sarah is known for her meticulous attention to detail and ability to maximize returns through precise classing techniques.',
                location: 'Victoria',
                certification: 'AWEX Certified Classer',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'sarah.williams@example.com | +61 3 9876 5432',
                ClasserID: 'AWEX-23456',
                AWEXRegistration: '2008-03-22',
                active_since: '2008'
              },
              
              // Testing Labs
              {
                id: 'lab-awta-01',
                type: 'testing_lab',
                name: 'AWTA Sydney Testing Center',
                code: 'AWTA-SYD',
                description: 'AWTA\'s primary wool testing facility in Sydney, providing comprehensive testing services including micron measurement, yield determination, staple length, and strength testing. The lab processes over 200,000 samples annually with industry-leading accuracy.',
                location: 'Sydney, NSW',
                certification: 'ISO 17025 Accredited',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'sydney@awta.com.au | +61 2 8765 4321',
                LabID: 'AWTA-SYD',
                TestingCapabilities: 'Full suite of wool testing services including micron, yield, CV, staple length/strength, color, VM content',
                AccreditationLevel: 'International'
              },
              
              // Brokers
              {
                id: 'broker-awh-01',
                type: 'broker',
                name: 'Australian Wool Handlers',
                code: 'AWH',
                description: 'Leading wool broker handling over 80% of Australian wool. AWH provides comprehensive services including wool receival, storage, testing coordination, and sale preparation. Their network spans all major wool producing regions in Australia.',
                location: 'Melbourne, VIC',
                certification: 'Industry Standard',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'info@awh.com.au | +61 3 9123 4567',
                BrokerCode: 'AWH',
                SaleRegions: 'National',
                AnnualVolume: '280 million kg'
              },
              
              // Auction Houses
              {
                id: 'auction-syd-01',
                type: 'auction_house',
                name: 'Sydney Wool Exchange',
                code: 'SYD-WE',
                description: 'Major wool auction center handling approximately 40% of Australia\'s wool sales. The Sydney Wool Exchange conducts regular auctions connecting growers with buyers from around the world.',
                location: 'Sydney, NSW',
                certification: 'AWEX Approved',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'auctions@sydneywoolexchange.com.au | +61 2 9876 5432',
                SaleCenter: 'Sydney',
                AnnualSales: '112 million kg',
                Locations: 'Yennora Wool Centre'
              },
              
              // Shipping Companies
              {
                id: 'shipping-maersk-01',
                type: 'shipping_company',
                name: 'Maersk Line',
                code: 'MAERSK',
                description: 'Global shipping company handling approximately 25% of wool exports from Australia to international markets. Maersk provides reliable container shipping with full traceability and condition monitoring.',
                location: 'Copenhagen, Denmark (Australian HQ: Sydney)',
                certification: 'ISO 9001, ISO 14001',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'wool.exports@maersk.com | +61 2 8765 4321',
                ShippingRoutes: 'Australia to China, Europe, Southeast Asia',
                FleetSize: '700+ vessels globally'
              },
              
              // Factories
              {
                id: 'factory-cn-shz-01',
                type: 'factory',
                name: 'Suzhou Wool Textile Co.',
                code: 'CN-SHZ-01',
                description: 'Major wool processing facility in Suzhou, China, specializing in early-stage wool processing including scouring, carding, and combing. The factory processes approximately 15 million kg of raw wool annually.',
                location: 'Suzhou, China',
                certification: 'RWS Certified, ISO 9001',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'info@suzhouwool.cn | +86 512 6762 5555',
                FactoryID: 'CN-SHZ-01',
                Country: 'China',
                ProcessingCapacity: '15 million kg annually'
              },
              
              // Brands
              {
                id: 'brand-patagonia-01',
                type: 'brand',
                name: 'Patagonia',
                code: 'PATAGONIA',
                description: 'Global outdoor clothing brand committed to sustainable and ethical wool sourcing. Patagonia requires full traceability of wool from farm to garment and maintains strict animal welfare standards.',
                location: 'Ventura, California, USA',
                certification: 'B Corp Certified, RWS Committed',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'wool.sourcing@patagonia.com | +1 800 638 6464',
                BrandID: 'PATAGONIA',
                Products: 'Outdoor apparel, merino base layers, insulated garments',
                Markets: 'Global',
                SustainabilityRating: 'A+'
              },
              
              // Certification Bodies
              {
                id: 'cert-rws-01',
                type: 'certification_body',
                name: 'Responsible Wool Standard',
                code: 'RWS',
                description: 'Global certification program that addresses the welfare of sheep and the land they graze on. RWS certification ensures farms meet strict animal welfare and land management requirements.',
                location: 'Multiple global offices',
                certification: 'ISEAL Member',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'info@responsiblewool.org | +1 512 222 3333',
                SchemeID: 'RWS',
                StandardsEnforced: 'Animal welfare, land management, social responsibility',
                AuditFrequency: 'Annual'
              },
              
              // Government Agencies
              {
                id: 'gov-awex-01',
                type: 'government_agency',
                name: 'Australian Wool Exchange (AWEX)',
                code: 'AWEX',
                description: 'Industry body responsible for wool quality standards, classer registration, and market reporting in Australia. AWEX maintains the National Wool Declaration program and conducts regular audits.',
                location: 'Sydney, NSW',
                certification: 'Government Authorized',
                updated_at: new Date().toISOString().split('T')[0],
                contact_info: 'info@awex.com.au | +61 2 9428 6100',
                AgencyID: 'AWEX',
                Jurisdiction: 'National',
                RegulatoryRole: 'Industry self-regulation, quality standards, market reporting'
              }
            ];
            
            // If search is empty, include all entities, otherwise filter based on search term
            if (searchTerm === '') {
              commercialEntities = allCommercialEntities;
              console.log('Empty search - including all mock commercial entities:', commercialEntities.length);
            } else {
              commercialEntities = allCommercialEntities.filter(entity => {
                const nameMatch = entity.name.toLowerCase().includes(searchTerm);
                const descMatch = entity.description.toLowerCase().includes(searchTerm);
                const typeMatch = entity.type.toLowerCase().includes(searchTerm);
                const codeMatch = entity.code && entity.code.toLowerCase().includes(searchTerm);
                
                const isMatch = nameMatch || descMatch || typeMatch || codeMatch;
                console.log(`Entity ${entity.name}: nameMatch=${nameMatch}, descMatch=${descMatch}, typeMatch=${typeMatch}, codeMatch=${codeMatch}, isMatch=${isMatch}`);
                
                return isMatch;
              });
            }
            
            // For testing: Always include at least one commercial entity
            if (commercialEntities.length === 0) {
              commercialEntities = [allCommercialEntities[0]]; // Include the first classer
              console.log('Added a default commercial entity for testing');
            }
            
            console.log('Using mock commercial entities (fallback):', commercialEntities);
            console.log('Number of commercial entities found:', commercialEntities.length);
          }
          
          // Add commercial entities to allResults
          allResults = [...allResults, ...commercialEntities];
          resultCount += commercialEntities.length;
          console.log('Added commercial entity results:', commercialEntities.length);
        } catch (commercialError) {
          console.error('Error fetching commercial entity data:', commercialError);
        }
        
        // Set the final search results
        const finalResults = {
          count: resultCount,
          results: allResults
        };
        
        // Post-process the search results to ensure farm data has correct owner information
        if (finalResults && finalResults.results) {
          // Farm owner mapping from the farm_profiles table
          const farmOwnerMapping = {
            'Kookaburra Plains': 'Ash & Mia Robertson',
            'Bluegum Ridge': 'Bluegum Ag Unit Trust',
            'Banksia Vale': 'Lee & Carter Pty Ltd',
            'Eucalyptus Park': 'Euca Holdings Pty Ltd',
            'Ironbark Station': 'Nguyen Family Trust',
            'Redbank Hill': 'Redbank Hill Estates',
            'Rivergum Plains': 'Rivergum Pastures Pty Ltd',
            'Snowy View': 'Snowy View Holdings',
            'Wattle Creek': 'Wattle Creek Family Trust',
            'Waratah Downs': 'Waratah Pastoral Co.'
          };
          
          // PIC to farm name mapping
          const picToFarmMapping = {
            'NSWBR9012': 'Bluegum Ridge',
            'NSWBV5566': 'Banksia Vale',
            'NSWEP2345': 'Eucalyptus Park',
            'NSWIB3344': 'Ironbark Station',
            'NSWKP1020': 'Kookaburra Plains',
            'NSWRH2468': 'Redbank Hill',
            'NSWRP4321': 'Rivergum Plains',
            'NSWSV1357': 'Snowy View',
            'NSWWC6789': 'Wattle Creek',
            'NSWWD7788': 'Waratah Downs'
          };
          
          // Region and LGA mapping
          const farmLocationMapping = {
            'Kookaburra Plains': { region: 'New England', lga: 'Armidale' },
            'Bluegum Ridge': { region: 'Northern Tablelands', lga: 'Glen Innes' },
            'Banksia Vale': { region: 'Riverina', lga: 'Wagga Wagga' },
            'Eucalyptus Park': { region: 'Hunter', lga: 'Singleton' },
            'Ironbark Station': { region: 'Central West', lga: 'Dubbo' },
            'Redbank Hill': { region: 'Central West', lga: 'Parkes' },
            'Rivergum Plains': { region: 'Riverina', lga: 'Narrandera' },
            'Snowy View': { region: 'Monaro', lga: 'Cooma-Monaro' },
            'Wattle Creek': { region: 'Central Tablelands', lga: 'Bathurst' },
            'Waratah Downs': { region: 'Monaro', lga: 'Snowy Monaro' }
          };
          
          // First, normalize all farm entries
          finalResults.results = finalResults.results.map(item => {
            if (item.type === 'farm') {
              // Get farm name either directly or via PIC mapping
              const farmName = item.name || picToFarmMapping[item.PIC] || '';
              
              // Get owner from mapping
              const owner = farmOwnerMapping[farmName];
              
              // Get location info
              const locationInfo = farmLocationMapping[farmName];
              
              if (owner || locationInfo) {
                return {
                  ...item,
                  name: farmName,
                  OwnerName: owner || item.OwnerName || 'Unknown Owner',
                  region: locationInfo?.region || item.region || 'Unknown',
                  LGA: locationInfo?.lga || item.LGA || ''
                };
              }
            }
            return item;
          });
          
          // Then, remove duplicate farm entries based on farm name
          const seenFarms = new Set();
          finalResults.results = finalResults.results.filter(item => {
            if (item.type === 'farm') {
              if (seenFarms.has(item.name)) {
                // This is a duplicate farm, skip it
                return false;
              }
              // Add this farm name to the set of seen farms
              seenFarms.add(item.name);
            }
            // Keep all non-farm items and the first instance of each farm
            return true;
          });
        }
        
        this.searchResults = finalResults
        console.log('Final search results:', this.searchResults)
        console.log('Farm entries in results:', this.searchResults?.results?.filter(item => item.type === 'farm'))
        console.log('Farm owners:', this.searchResults?.results?.filter(item => item.type === 'farm').map(f => f.OwnerName))
        console.log('Commercial entities in results:', this.searchResults?.results?.filter(item => this.isCommercialEntity(item.type)))
        console.log('Commercial entity types:', this.searchResults?.results?.filter(item => this.isCommercialEntity(item.type)).map(e => e.type))
        
        // Enrich results with contextual insights
        await this.enrichResultsWithInsights();
      } catch (error) {
        console.error('Search error:', error);
        this.searchResults = { count: 0, results: [] };
      } finally {
        this.loading = false;
      }
    },
    
    async enrichResultsWithInsights() {
      if (!this.searchResults || !this.searchResults.results) return;
      
      // Enrich each result with contextual insights
      for (const item of this.searchResults.results) {
        try {
          const insights = await this.fetchContextualInsights(item);
          item.contextualInsights = insights;
        } catch (error) {
          console.error('Error fetching insights for item:', item, error);
        }
      }
    },
    
    async fetchContextualInsights(item) {
      const insights = [];
      
      try {
        // For farms: count related wool lines, consignments, audits
        if (item.type === 'farm') {
          const pic = item.PIC || item.pic;
          
          if (pic) {
            // Count wool lines from this farm
            const { count: woolLineCount } = await this.$supabase
              .from('trace_index')
              .select('*', { count: 'exact', head: true })
              .eq('PIC', pic);
            
            if (woolLineCount > 0) {
              insights.push(`${woolLineCount} wool line${woolLineCount !== 1 ? 's' : ''}`);
            }
            
            // Count consignments - trace through trace_index to find consignments from this farm
            const { data: traceRecords, error: traceError } = await this.$supabase
              .from('trace_index')
              .select('ConsignmentID')
              .eq('PIC', pic)
              .not('ConsignmentID', 'is', null);
            
            if (!traceError && traceRecords) {
              const uniqueConsignments = [...new Set(traceRecords.map(r => r.ConsignmentID))];
              const consignmentCount = uniqueConsignments.length;
              
              if (consignmentCount > 0) {
                insights.push(`${consignmentCount} consignment${consignmentCount !== 1 ? 's' : ''}`);
              }
            }
          }
        }
        
        // For wool lines: count related bales, test results
        if (item.type === 'wool_line') {
          const lineId = item.LineID || item.lineId || item.code;
          
          if (lineId) {
            // Count bales
            const { count: baleCount } = await this.$supabase
              .from('bale_register')
              .select('*', { count: 'exact', head: true })
              .eq('LineID', lineId);
            
            if (baleCount > 0) {
              insights.push(`${baleCount} bale${baleCount !== 1 ? 's' : ''}`);
            }
          }
        }
        
        // For factories: count incoming consignments, production batches
        if (item.type === 'factory') {
          const factoryId = item.FactoryID || item.code;
          
          if (factoryId) {
            // Count factory inputs
            const { count: inputCount } = await this.$supabase
              .from('factory_inputs')
              .select('*', { count: 'exact', head: true })
              .eq('FactoryID', factoryId);
            
            if (inputCount > 0) {
              insights.push(`${inputCount} incoming shipment${inputCount !== 1 ? 's' : ''}`);
            }
            
            // Count production batches
            const { count: batchCount } = await this.$supabase
              .from('spinning_records')
              .select('*', { count: 'exact', head: true })
              .eq('FactoryID', factoryId);
            
            if (batchCount > 0) {
              insights.push(`${batchCount} production batch${batchCount !== 1 ? 'es' : ''}`);
            }
          }
        }
        
        // For exports: count containers, destination info
        if (item.type === 'export' || item.type === 'consignment') {
          const consignmentId = item.ConsignmentID || item.code;
          
          if (consignmentId && item.ContainerIDs) {
            const containerCount = Array.isArray(item.ContainerIDs) ? item.ContainerIDs.length : 1;
            insights.push(`${containerCount} container${containerCount !== 1 ? 's' : ''}`);
          }
          
          if (item.DestinationCountry) {
            insights.push(`to ${item.DestinationCountry}`);
          }
        }
        
      } catch (error) {
        console.error('Error fetching contextual insights:', error);
      }
      
      return insights.length > 0 ? insights.join(' • ') : null;
    },
    
    toggleSortDropdown() {
      this.showSortDropdown = !this.showSortDropdown;
    },
    
    setSortOption(option) {
      this.sortOption = option;
      this.showSortDropdown = false;
      
      // Sort the results based on the selected option
      if (this.searchResults && this.searchResults.results) {
        const results = [...this.searchResults.results];
        
        switch(option) {
          case 'Type':
            results.sort((a, b) => a.type.localeCompare(b.type));
            break;
          case 'Origin':
            results.sort((a, b) => a.origin_farm.localeCompare(b.origin_farm));
            break;
          case 'Destination':
            results.sort((a, b) => a.destination.localeCompare(b.destination));
            break;
        }
        
        this.searchResults = {
          count: this.searchResults.count,
          results: results
        };
      }
    },
    
    showDetails(item) {
      
      // Scroll to top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      this.loadItemDetails(item)
    },
    
    async loadItemDetails(item) {
      console.log('loadItemDetails called with item:', item);
      this.selectedItem = item;
      this.viewMode = 'detail';
      // Set appropriate default tab based on entity type
      this.activeTab = item.type === 'farm' ? 'details' : item.type === 'wool_line' ? 'list-view' : 'details';
      
      // Load notifications for this entity (don't block rendering if it fails)
      try {
        await this.loadEntityNotifications(item);
      } catch (error) {
        console.error('Error loading notifications:', error);
        this.entityNotifications = [];
      }
      
      // Load additional details (commercial entities, farm data, etc.)
      await this.loadAdditionalItemDetails(item);
    },
    
    addToRecentItems(item) {
      console.log('addToRecentItems called with:', item);
      // Create a recent item object with relevant info
      const recentItem = {
        type: this.formatItemType(item.type),
        name: item.name || item.code || item.PIC || item.id || 'Unknown',
        originalItem: item
      };
      console.log('Created recent item:', recentItem);
      
      // Check if item already exists in recent items
      const existingIndex = this.recentItems.findIndex(
        recent => recent.name === recentItem.name && recent.type === recentItem.type
      );
      
      // If it exists, remove it (we'll add it to the front)
      if (existingIndex !== -1) {
        this.recentItems.splice(existingIndex, 1);
      }
      
      // Add to the beginning of the array
      this.recentItems.unshift(recentItem);
      
      // Keep only the last 5 items
      if (this.recentItems.length > 5) {
        this.recentItems = this.recentItems.slice(0, 5);
      }
      
      // Save to sessionStorage
      try {
        sessionStorage.setItem('agricore_recent_items', JSON.stringify(this.recentItems));
        console.log('Saved recent items to sessionStorage:', this.recentItems);
      } catch (e) {
        console.error('Error saving recent items to sessionStorage:', e);
      }
    },
    
    selectRecentItem(recentItem) {
      // Re-select the original item
      this.showDetails(recentItem.originalItem);
      // Close mobile sidebar after selection
      if (window.innerWidth <= 768) {
        this.isMobileSidebarOpen = false;
      }
    },
    
    toggleMobileSidebar() {
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    },
    
    closeMobileSidebar() {
      if (window.innerWidth <= 768) {
        this.isMobileSidebarOpen = false;
      }
    },
    
    // Custom Chat Methods
    async handleCustomChatSubmit() {
      if (!this.customChatInput.trim() || this.customChatLoading) return;
      
      const userMessage = this.customChatInput.trim();
      this.customChatInput = '';
      
      // Add user message to chat
      this.customChatMessages.push({
        role: 'user',
        content: userMessage,
        timestamp: new Date()
      });
      
      // Auto-scroll to bottom
      this.$nextTick(() => {
        this.scrollCustomChatToBottom();
      });
      
      // Call n8n webhook
      this.customChatLoading = true;
      this.startLoadingMessageCycle();
      
      try {
        const webhookUrl = import.meta.env.VITE_N8N_WEBHOOK_URL || '';
        
        if (!webhookUrl) {
          throw new Error('Webhook URL not configured');
        }
        
        const response = await fetch(webhookUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            chatInput: userMessage,
            sessionId: this.getCustomChatSessionId()
          })
        });
        
        const data = await response.json();
        
        // Add assistant response to chat with markdown formatting and chart detection
        const responseText = data.output || data.response || data.message || 'Sorry, I could not process your request.';
        const parsedMessage = this.parseMessageForChart(responseText);
        
        this.customChatMessages.push({
          role: 'bot',
          content: this.formatMarkdown(parsedMessage.text),
          chartData: parsedMessage.chartData,
          timestamp: new Date()
        });
        
        // Render chart if present
        if (parsedMessage.chartData) {
          this.$nextTick(() => {
            this.renderChart(this.customChatMessages.length - 1, parsedMessage.chartData);
          });
        }
        
      } catch (error) {
        console.error('Chat error:', error);
        this.customChatMessages.push({
          role: 'bot',
          content: 'Sorry, there was an error processing your message. Please try again.',
          timestamp: new Date()
        });
      } finally {
        this.stopLoadingMessageCycle();
        this.customChatLoading = false;
        this.$nextTick(() => {
          this.scrollCustomChatToBottom();
        });
      }
    },
    
    getCustomChatSessionId() {
      let sessionId = sessionStorage.getItem('custom_chat_session_id');
      if (!sessionId) {
        sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem('custom_chat_session_id', sessionId);
      }
      return sessionId;
    },
    
    scrollCustomChatToBottom() {
      const messagesContainer = this.$refs.customChatMessages;
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    },
    
    startLoadingMessageCycle() {
      // Reset to first message
      this.currentLoadingMessageIndex = 0;
      
      // Cycle through messages every 3 seconds
      this.loadingMessageInterval = setInterval(() => {
        this.currentLoadingMessageIndex = (this.currentLoadingMessageIndex + 1) % this.loadingMessages.length;
      }, 3000);
    },
    
    stopLoadingMessageCycle() {
      if (this.loadingMessageInterval) {
        clearInterval(this.loadingMessageInterval);
        this.loadingMessageInterval = null;
      }
      this.currentLoadingMessageIndex = 0;
    },
    
    formatMarkdown(text) {
      if (!text) return '';
      try {
        return marked.parse(text);
      } catch (error) {
        console.error('Markdown parsing error:', error);
        return text;
      }
    },
    
    parseMessageForChart(text) {
      // Look for JSON chart data in the response
      // Expected format: ```chart\n{...json...}\n```
      const chartRegex = /```chart\n([\s\S]*?)\n```/;
      const match = text.match(chartRegex);
      
      if (match) {
        try {
          const chartData = JSON.parse(match[1]);
          // Remove the chart block from the text
          const cleanText = text.replace(chartRegex, '').trim();
          return {
            text: cleanText,
            chartData: chartData
          };
        } catch (error) {
          console.error('Error parsing chart data:', error);
          return { text: text, chartData: null };
        }
      }
      
      return { text: text, chartData: null };
    },
    
    renderChart(messageIndex, chartData) {
      const canvasId = 'chart-' + messageIndex;
      const canvas = document.getElementById(canvasId);
      
      if (!canvas) {
        console.error('Canvas not found:', canvasId);
        return;
      }
      
      const ctx = canvas.getContext('2d');
      
      // Default chart configuration
      const defaultConfig = {
        type: chartData.type || 'bar',
        data: chartData.data || {},
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: chartData.showLegend !== false,
              position: 'top',
            },
            title: {
              display: !!chartData.title,
              text: chartData.title || ''
            }
          },
          scales: chartData.type !== 'pie' && chartData.type !== 'doughnut' ? {
            y: {
              beginAtZero: true
            }
          } : {}
        }
      };
      
      // Merge with custom options if provided
      const config = chartData.options 
        ? { ...defaultConfig, options: { ...defaultConfig.options, ...chartData.options } }
        : defaultConfig;
      
      // Create the chart
      new Chart(ctx, config);
    },
    
    toggleMobileAIPanel() {
      this.isMobileAIPanelOpen = !this.isMobileAIPanelOpen;
    },
    
    formatItemType(type) {
      // Format the type for display
      const typeMap = {
        'farm': 'Farm',
        'wool_line': 'Wool Line',
        'shipping_company': 'Shipping Company',
        'processor': 'Processor',
        'manufacturer': 'Manufacturer',
        'retailer': 'Retailer',
        'exporter': 'Exporter',
        'broker': 'Broker'
      };
      return typeMap[type] || type.charAt(0).toUpperCase() + type.slice(1);
    },
    
    async loadAdditionalItemDetails(item) {
      // Load additional details from Supabase for the selected item
      console.log('Loading additional item details for:', item);
      this.relatedItems = []; // Reset related items
      
      try {
        // If this is a commercial entity item, fetch details from Supabase
        if (this.isCommercialEntity(item.type)) {
          console.log('Loading commercial entity details for:', item);
          
          try {
            // Get the entity ID and type
            const entityId = item.id;
            const entityType = item.type;
            
            if (entityId) {
              // Fetch commercial entity details from Supabase
              const entityResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities?id=eq.${entityId}`, {
                method: 'GET',
                headers: {
                  'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                  'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
                }
              });
              
              if (entityResponse.ok) {
                const entityData = await entityResponse.json();
                console.log('Commercial entity details from Supabase:', entityData);
                
                if (entityData && entityData.length > 0) {
                  // Update the selected item with additional details
                  Object.assign(this.selectedItem, entityData[0]);
                  
                  // Fetch trace_index data to find related items
                  const traceIndexResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index`, {
                    method: 'GET',
                    headers: {
                      'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                      'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
                    }
                  });
                  
                  if (traceIndexResponse.ok) {
                    const traceIndexData = await traceIndexResponse.json();
                    console.log('Trace index data:', traceIndexData);
                    
                    // Use Fuse.js to search for related items based on entity type
                    let searchKey = '';
                    let searchValue = '';
                    
                    switch(entityType) {
                      case 'classer':
                        searchKey = 'ClasserID';
                        searchValue = item.ClasserID || item.code;
                        break;
                      case 'broker':
                        searchKey = 'BrokerCode';
                        searchValue = item.BrokerCode || item.code;
                        break;
                      case 'factory':
                        searchKey = 'FactoryID';
                        searchValue = item.FactoryID || item.code;
                        break;
                      case 'brand':
                        searchKey = 'Brand';
                        searchValue = item.name;
                        break;
                      case 'testing_lab':
                        searchKey = 'TestCertID';
                        searchValue = item.LabID || item.code;
                        break;
                      case 'auction_house':
                        searchKey = 'SaleCenter';
                        searchValue = item.SaleCenter || item.code;
                        break;
                      case 'shipping_company':
                        searchKey = 'FreightCompany';
                        searchValue = item.name;
                        break;
                      case 'port':
                        searchKey = 'PortID';
                        searchValue = item.PortID || item.code;
                        break;
                      default:
                        // For other entity types, try to match by name
                        searchKey = 'name';
                        searchValue = item.name;
                    }
                    
                    if (searchKey && searchValue) {
                      // Configure Fuse.js for fuzzy searching
                      const fuseOptions = {
                        includeScore: true,
                        threshold: 0.4,
                        keys: [searchKey]
                      };
                      
                      const fuse = new Fuse(traceIndexData, fuseOptions);
                      const results = fuse.search(searchValue);
                      console.log(`Fuse.js search results for ${searchKey}=${searchValue}:`, results);
                      
                      // Process the results
                      this.relatedItems = results.map(result => {
                        const item = result.item;
                        let dateValue = null;
                        
                        // Try to find a valid date field
                        if (item.SaleDateTime && !isNaN(new Date(item.SaleDateTime).getTime())) {
                          dateValue = item.SaleDateTime;
                        } else if (item.ShearingDate && !isNaN(new Date(item.ShearingDate).getTime())) {
                          dateValue = item.ShearingDate;
                        } else if (item.updated_at && !isNaN(new Date(item.updated_at).getTime())) {
                          dateValue = item.updated_at;
                        } else {
                          // Use current date as fallback
                          dateValue = new Date().toISOString();
                        }
                        
                        // Create the related item with basic info
                        const relatedItem = {
                          displayName: `Wool Line: ${item.LineID || 'Unknown'}`,
                          origin: item.FarmName || 'Unknown Farm',
                          date: dateValue,
                          id: item.id,
                          type: 'wool_line',
                          lineId: item.LineID
                        };
                        
                        // For shipping companies, include port information
                        if (this.selectedItem.type === 'shipping_company' && item.PortID) {
                          // Map port IDs to port names
                          const portMap = {
                            'AUS-NSW-PBT': 'Port Botany',
                            'AUS-QLD-BNE': 'Port of Brisbane',
                            // Add more port mappings as needed
                          };
                          
                          relatedItem.portName = portMap[item.PortID] || item.PortID;
                        }
                        
                        return relatedItem;
                      });
                    }
                    
                    // If no results found with Fuse.js, try direct matching
                    if (this.relatedItems.length === 0) {
                      const directMatches = traceIndexData.filter(item => {
                        return item[searchKey] === searchValue;
                      });
                      
                      console.log(`Direct matches for ${searchKey}=${searchValue}:`, directMatches);
                      
                      this.relatedItems = directMatches.map(item => {
                        let dateValue = null;
                        
                        // Try to find a valid date field
                        if (item.SaleDateTime && !isNaN(new Date(item.SaleDateTime).getTime())) {
                          dateValue = item.SaleDateTime;
                        } else if (item.ShearingDate && !isNaN(new Date(item.ShearingDate).getTime())) {
                          dateValue = item.ShearingDate;
                        } else if (item.updated_at && !isNaN(new Date(item.updated_at).getTime())) {
                          dateValue = item.updated_at;
                        } else {
                          // Use current date as fallback
                          dateValue = new Date().toISOString();
                        }
                        
                        // Create the related item with basic info
                        const relatedItem = {
                          displayName: `Wool Line: ${item.LineID || 'Unknown'}`,
                          origin: item.FarmName || 'Unknown Farm',
                          date: dateValue,
                          id: item.id,
                          type: 'wool_line',
                          lineId: item.LineID
                        };
                        
                        // For shipping companies, include port information
                        if (this.selectedItem.type === 'shipping_company' && item.PortID) {
                          // Map port IDs to port names
                          const portMap = {
                            'AUS-NSW-PBT': 'Port Botany',
                            'AUS-QLD-BNE': 'Port of Brisbane',
                            // Add more port mappings as needed
                          };
                          
                          relatedItem.portName = portMap[item.PortID] || item.PortID;
                        }
                        
                        return relatedItem;
                      });
                    }
                  }
                }
              }
            }
          } catch (error) {
            console.error('Error fetching commercial entity details:', error);
          }
          
          return; // Exit early as we've set all needed details
        }
        // If this is a farm item, use the backend controller to get farm details
        if (item.type === 'farm') {
          const pic = item.PIC;
          if (pic) {
            try {
              // Make a request to the backend controller to get farm details
              const farmResponse = await fetch(`/api/farm/${pic}`, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
                }
              });
              
              if (farmResponse.ok) {
                const farmData = await farmResponse.json();
                console.log('Farm details from backend:', farmData);
                
                if (farmData && Object.keys(farmData).length > 0) {
                  // Set farm details from backend data
                  this.farmDetails = {
                    location: farmData.location || `${farmData.Region || 'Unknown'}, ${farmData.LGA || 'Unknown'}`,
                    PIC: pic,
                    type: farmData.type || 'wool', // Include farm type for image selection
                    certification: farmData.certification || (farmData.SustainaWool ? 'SustainaWool Certified' : 'Standard'),
                    mob_id: farmData.mob_id || farmData.MobID || 'Unknown',
                    owner: farmData.OwnerName || selectedItem.OwnerName || 'Unknown Owner', // Use actual owner from database or fallback to specific owner
                    Scope3_Compliant: farmData.Scope3_Compliant || false, // Default to false if not specified
                    CarbonReportingStatus: farmData.CarbonReportingStatus || 'NGER Scope 1 (Estimated) Tier 2), Scope 1+2',
                    Products: farmData.Products || 'Prime lamb, wheat, canola, and chickpeas'
                  };
                  
                  // Set item details from backend data
                  this.itemDetails = {
                    total_days: farmData.total_days || farmData.ProcessingDays || Math.floor(Math.random() * 30) + 60,
                    weight_kg: farmData.weight_kg || farmData.TotalWoolWeight || (Math.random() * 100 + 150).toFixed(1),
                    micron_um: farmData.micron_um || farmData.AverageMicron || (Math.random() * 5 + 16).toFixed(1),
                    price_cents_kg: farmData.price_cents_kg || farmData.AveragePrice || Math.floor(Math.random() * 500 + 1000),
                    sheep_count: farmData.sheep_count || farmData.TotalSheep || Math.floor(Math.random() * 100 + 150),
                    fabric_rolls: farmData.fabric_rolls || farmData.FabricRolls || Math.floor(Math.random() * 10 + 5),
                    description: farmData.description || `${farmData.FarmName || item.name} is a ${this.farmDetails.certification} wool producing farm located in ${this.farmDetails.location}.`,
                    classer: farmData.classer || farmData.ClasserInfo || 'Unknown',
                    bales_info: farmData.bales_info || farmData.BalesInfo || 'Information not available'
                  };
                  
                  // Fetch mulesing status from nwd_declarations for this farm
                  try {
                    const nwdResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/nwd_declarations?PIC=eq.${pic}&select=*`, {
                      headers: {
                        'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                        'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
                      }
                    });
                    
                    if (nwdResponse.ok) {
                      const nwdData = await nwdResponse.json();
                      console.log('NWD data for farm:', nwdData);
                      
                      if (nwdData && nwdData.length > 0) {
                        // Add mulesing status to itemDetails
                        this.itemDetails.MulesingStatus = nwdData[0].MulesingStatus || 'Unknown';
                        console.log('Added mulesing status to itemDetails:', this.itemDetails.MulesingStatus);
                      }
                    }
                  } catch (nwdError) {
                    console.error('Error fetching NWD data for farm:', nwdError);
                  }
                  
                  console.log('Set farmDetails from backend data:', this.farmDetails);
                  return; // Exit early as we've set all needed details
                }
              }
              
              // If we get here, the backend request failed or returned no data
              // Fall back to mock data
              console.log('Falling back to mock farm details');
            } catch (error) {
              console.error('Error fetching farm details from backend:', error);
              // Fall back to mock data
            }
          }
          
          // Use mock farm details as a fallback
          console.log('Using mock farm details');
          
          // Mock farm details based on the PIC
          const mockFarmDetails = {
            'NSW123456': {
              location: 'New South Wales, Central Tablelands',
              certification: 'SustainaWool Certified',
              mob_id: 'KOO-2022-W-TH-1 (219 head)',
              OwnerName: 'Ash & Mia Robertson',
              total_days: 75,
              weight_kg: 187.5,
              micron_um: 18.7,
              price_cents_kg: 1250,
              sheep_count: 219,
              fabric_rolls: 8,
              description: 'Kookaburra Plains is a SustainaWool Certified wool producing farm located in the Central Tablelands of New South Wales. The farm specializes in fine merino wool production with a focus on sustainable farming practices.',
              classer: 'Robert Johnson (AWEX #12345)',
              bales_info: '12 bales (KP001-KP012) - 187.5kg total',
              MulesingStatus: 'NM' // Non-mulesed
            },
            'VIC789012': {
              location: 'Victoria, Western District',
              certification: 'RWS Certified',
              mob_id: 'MH-2022-W-SG-2 (185 head)',
              OwnerName: 'James & Sarah Wilson',
              total_days: 82,
              weight_kg: 172.3,
              micron_um: 19.2,
              price_cents_kg: 1180,
              sheep_count: 185,
              fabric_rolls: 7,
              description: 'Merino Heights is an RWS Certified wool producing farm located in the Western District of Victoria. The farm is known for its commitment to responsible wool standards and animal welfare.',
              classer: 'Sarah Williams (AWEX #23456)',
              bales_info: '10 bales (MH001-MH010) - 172.3kg total',
              MulesingStatus: 'NM' // Non-mulesed
            },
            'SA456789': {
              location: 'South Australia, Flinders Ranges',
              certification: 'Standard',
              mob_id: 'WD-2022-W-FG-3 (230 head)',
              OwnerName: 'Thomas Anderson',
              total_days: 68,
              weight_kg: 195.8,
              micron_um: 20.1,
              price_cents_kg: 1050,
              sheep_count: 230,
              fabric_rolls: 9,
              description: 'Woolly Downs is a traditional wool producing farm located in the Flinders Ranges of South Australia. The farm has been in operation for over 100 years and is known for its consistent wool quality.',
              classer: 'Michael Thompson (AWEX #34567)',
              bales_info: '13 bales (WD001-WD013) - 195.8kg total',
              MulesingStatus: 'CM' // Ceased mulesing
            },
            'QLD234567': {
              location: 'Queensland, Darling Downs',
              certification: 'Organic Certified',
              mob_id: 'QM-2022-W-DD-4 (175 head)',
              OwnerName: 'Emma & Michael Johnson',
              total_days: 70,
              weight_kg: 165.2,
              micron_um: 18.9,
              price_cents_kg: 1320,
              sheep_count: 175,
              fabric_rolls: 6,
              description: 'Queensland Merino is an Organic Certified wool producing farm located in the Darling Downs region of Queensland. The farm focuses on organic farming practices and produces premium quality merino wool.',
              classer: 'Jennifer Brown (AWEX #45678)',
              bales_info: '9 bales (QM001-QM009) - 165.2kg total',
              MulesingStatus: 'NM' // Non-mulesed
            }
          };
          
          if (pic && mockFarmDetails[pic]) {
            // Set farm details from mock data
            const details = mockFarmDetails[pic];
            
            this.farmDetails = {
              location: details.location,
              PIC: pic,
              certification: details.certification,
              mob_id: details.mob_id
            };
            
            // Set item details from mock data
            this.itemDetails = {
              total_days: details.total_days,
              weight_kg: details.weight_kg,
              micron_um: details.micron_um,
              price_cents_kg: details.price_cents_kg,
              sheep_count: details.sheep_count,
              fabric_rolls: details.fabric_rolls,
              description: details.description,
              classer: details.classer,
              bales_info: details.bales_info,
              MulesingStatus: details.MulesingStatus || 'Unknown'
            };
          } else {
            // If no specific mock data for this PIC, use generic information
            this.farmDetails = {
              location: item.region || 'Unknown',
              PIC: item.PIC || 'Unknown',
              certification: item.certification || 'Standard',
              mob_id: 'Unknown',
              owner: item.OwnerName || (item.name === 'Kookaburra Plains' ? 'Ash & Mia Robertson' : 'Unknown Owner'),
              Scope3_Compliant: item.Scope3_Compliant || false,
              CarbonReportingStatus: item.CarbonReportingStatus || 'NGER Scope 1 (Estimated) Tier 2), Scope 1+2',
              Products: item.Products || 'Prime lamb, wheat, canola, and chickpeas'
            };
            
            // Set some basic item details
            this.itemDetails = {
              total_days: Math.floor(Math.random() * 30) + 60,
              weight_kg: (Math.random() * 100 + 150).toFixed(1),
              micron_um: (Math.random() * 5 + 16).toFixed(1),
              price_cents_kg: Math.floor(Math.random() * 500 + 1000),
              sheep_count: Math.floor(Math.random() * 100 + 150),
              fabric_rolls: Math.floor(Math.random() * 10 + 5),
              description: `${item.name} is a ${item.certification || 'standard'} wool producing farm located in ${item.region || 'Australia'}.`,
              classer: 'Information not available',
              bales_info: 'Information not available',
              MulesingStatus: item.MulesingStatus || 'NM' // Default to non-mulesed if not specified
            };
          }
          
          console.log('Set farmDetails for farm item:', this.farmDetails);
          return; // Exit early as we've set all needed details
        }
        
        // For non-farm items, proceed with the original logic
        // Get farm details if we have PIC
        const pic = item.raw_data?.PIC || item.PIC;
        if (pic) {
          const farmResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/farm_profiles?PIC=eq.${pic}&select=*`, {
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
            }
          })
          const farmData = await farmResponse.json()
          console.log('Farm data response:', farmData);
          if (farmData && farmData.length > 0) {
            this.farmDetails = {
              location: `${farmData[0].Region}, ${farmData[0].LGA}`,
              PIC: farmData[0].PIC,
              certification: farmData[0].SustainaWool ? 'SustainaWool Certified' : 'Standard',
              mob_id: 'KOO-2022-W-TH-1 (219 head)' // This would need to come from another table
            }
            console.log('Set farmDetails:', this.farmDetails);
          }
        }
        
        // Get factory details if we have FactoryID
        const factoryID = item.raw_data?.FactoryID || item.FactoryID;
        if (factoryID) {
          const factoryResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/factories?FactoryID=eq.${factoryID}&select=*`, {
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
            }
          })
          const factoryData = await factoryResponse.json()
          console.log('Factory data response:', factoryData);
          if (factoryData && factoryData.length > 0) {
            this.factoryDetails = {
              name: factoryData[0].Name,
              factory_id: factoryData[0].FactoryID,
              country: factoryData[0].Country,
              certification: factoryData[0].Certification || 'Standard'
            }
            console.log('Set factoryDetails:', this.factoryDetails);
          }
        }
        
        // Get export details if we have ConsignmentID
        const consignmentID = item.raw_data?.ConsignmentID || item.ConsignmentID;
        if (consignmentID) {
          const exportResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/export_documents?ConsignmentID=eq.${consignmentID}&select=*`, {
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
            }
          })
          const exportData = await exportResponse.json()
          console.log('Export data response:', exportData);
          if (exportData && exportData.length > 0) {
            this.exportDetails = {
              consignment_id: exportData[0].ConsignmentID,
              permit: exportData[0].ExportPermitNo,
              port: `${exportData[0].PortID} (${exportData[0].UNLocode})`,
              containers: exportData[0].ContainerIDs,
              freight_company: exportData[0].FreightCompany
            }
            console.log('Set exportDetails:', this.exportDetails);
          }
        }
        
        // Initialize itemDetails with default values
        this.itemDetails = {
          total_days: Math.floor(Math.random() * 30) + 60, // Simulate 60-90 days total processing time
          weight_kg: (Math.random() * 100 + 150).toFixed(1), // Simulate 150-250kg weight
          micron_um: (Math.random() * 5 + 16).toFixed(1), // Simulate 16-21 micron
          price_cents_kg: Math.floor(Math.random() * 500 + 1000), // Simulate 1000-1500 cents per kg
          sheep_count: Math.floor(Math.random() * 100 + 150), // Simulate 150-250 sheep
          fabric_rolls: Math.floor(Math.random() * 10 + 5), // Simulate 5-15 fabric rolls
          description: '',
          classer: '',
          bales_info: ''
        }
        
        // Get the LineID from the selected item
        const lineID = item.raw_data?.LineID || item.LineID || item.code;
        
        if (lineID) {
          // Fetch wool description from nwd_declarations
          const nwdResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/nwd_declarations?LineID=eq.${lineID}&select=*`, {
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
            }
          });
          
          const nwdData = await nwdResponse.json();
          console.log('NWD data response:', nwdData);
          
          if (nwdData && nwdData.length > 0) {
            // Update description with real data
            this.itemDetails.description = nwdData[0].Description || 
              `${nwdData[0].WoolType || 'Merino'} wool, ${nwdData[0].MulesingStatus || 'NM'} mulesing status` +
              `${nwdData[0].VMContent ? ', VM content: ' + nwdData[0].VMContent : ''}`;
            
            // Get ClasserID to fetch classer information
            const classerID = nwdData[0].ClasserID;
            if (classerID) {
              const classerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/classer_register?ClasserID=eq.${classerID}&select=*`, {
                headers: {
                  'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                  'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
                }
              });
              
              const classerData = await classerResponse.json();
              console.log('Classer data response:', classerData);
              
              if (classerData && classerData.length > 0) {
                // Update classer information with real data
                this.itemDetails.classer = `${classerData[0].ClasserName} (AWEX #${classerID})`;
              } else {
                this.itemDetails.classer = `Classer ID: ${classerID}`;
              }
            }
          } else {
            this.itemDetails.description = 'No detailed wool description available';
          }
          
          // Fetch bales information from bale_register
          const baleResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/bale_register?LineID=eq.${lineID}&select=*`, {
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V'
            }
          });
          
          const baleData = await baleResponse.json();
          console.log('Bale data response:', baleData);
          
          if (baleData && baleData.length > 0) {
            // Calculate total weight
            let totalWeight = 0;
            const baleIDs = [];
            
            baleData.forEach(bale => {
              totalWeight += parseFloat(bale.Weight_kg || 0);
              if (bale.BaleID) baleIDs.push(bale.BaleID);
            });
            
            // Update bales information with real data
            this.itemDetails.bales_info = `${baleData.length} bales ` + 
              (baleIDs.length > 0 ? `(${baleIDs.join(', ')})` : '') + 
              ` - ${totalWeight.toFixed(1)}kg total`;
            
            // Update weight_kg with actual data
            this.itemDetails.weight_kg = totalWeight.toFixed(1);
          } else {
            this.itemDetails.bales_info = 'No bale information available';
          }
        }
      } catch (error) {
        console.error('Error loading item details:', error);
      }
    },
    
    backToSearch() {
      this.viewMode = 'search'
      this.selectedItem = null
      this.activeTab = 'list-view'
    },
    
    navigateToFarm(pic, farmName) {
      console.log('Navigating to farm:', pic, farmName);
      
      // Create a farm item object
      const farmItem = {
        id: `farm-${pic}`,
        type: 'farm',
        name: farmName,
        PIC: pic
      };
      
      // Navigate to the farm details
      this.showDetails(farmItem);
    },
    
    showPreAuditGuidance() {
      // Keep the selectedItem but change the view mode
      this.viewMode = 'pre-audit-guidance'
      // Scroll to top
      window.scrollTo(0, 0);
    },
    
    showAuditFindings() {
      // Keep the selectedItem but change the view mode
      this.viewMode = 'audit-findings'
      // Scroll to top
      window.scrollTo(0, 0);
    },
    
    backToDetail() {
      this.viewMode = 'detail'
      this.processedAuditReport = null;
      
      // Scroll to top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    
    handleAuditReport(file) {
      console.log('SearchComponent: Received audit report from AI Assistant:', file);
      // If we're not already showing the pre-audit guidance, show it
      if (!this.showingPreAuditGuidance) {
        console.log('SearchComponent: Showing pre-audit guidance');
        this.showPreAuditGuidance();
      } else {
        console.log('SearchComponent: Pre-audit guidance already showing');
      }
      
      // Pass the file to the PreAuditGuidance component
      console.log('SearchComponent: Setting processedAuditReport');
      this.processedAuditReport = file;
      console.log('SearchComponent: processedAuditReport set to:', this.processedAuditReport);
    },
    
    async loadConnectionsData() {
      // Always reload data to ensure we have the latest
      this.connectionData = [];
      this.loadingConnections = true;
      
      try {
        // Get the appropriate ID and type for the current entity
        const entityId = this.selectedItem.id;
        const entityType = this.selectedItem.type;
        
        // For farms, load wool lines and related entities
        if (entityType === 'farm') {
          await this.loadFarmConnectionsFromSupabase(entityId);
        } 
        // For classers, load their connections
        else if (entityType === 'classer') {
          await this.loadClasserConnectionsFromSupabase(entityId);
        }
        // For wool lines, load their connections
        else if (entityType === 'wool_line') {
          await this.loadWoolLineConnectionsFromSupabase(entityId);
        }
        // For other commercial entities, load their connections
        else if (this.isCommercialEntity(entityType)) {
          await this.loadCommercialEntityConnectionsFromSupabase(entityId, entityType);
        }
      } catch (error) {
        console.error('Error loading connections data:', error);
        this.connectionData = [];
      } finally {
        this.loadingConnections = false;
      }
    },
    
    async loadFarmConnectionsFromSupabase(farmId) {
      try {
        console.log('Loading farm connections for farmId:', farmId);
        // Extract PIC from farmId if it's in the format 'farm-PIC'
        let picValue = farmId;
        if (farmId.includes('-')) {
          picValue = farmId.split('-')[1];
        }
        
        // Get the farm details first
        const farmResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/farm_profiles?PIC=eq.${picValue}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Content-Type': 'application/json'
          }
        });
        
        const farmData = await farmResponse.json();
        if (!farmData || farmData.length === 0) {
          console.error('Farm not found for PIC:', picValue);
          return;
        }
        
        const farm = farmData[0];
        if (!farm || !farm.PIC) {
          console.error('Farm data is missing PIC property:', farm);
          return;
        }
        
        // Create the main farm node
        const farmNode = {
          id: `farm-${farm.PIC}`,
          name: farm.FarmName || 'Unknown Farm',
          type: 'farm',
          pic: farm.PIC,
          connections: []
        };
        
        // Get wool lines associated with this farm using trace_index
        const traceResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?PIC=eq.${farm.PIC}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Content-Type': 'application/json'
          }
        });
        
        const traceData = await traceResponse.json();
        if (!traceData || traceData.length === 0) {
          console.log('No wool lines found for this farm, returning just the farm node');
          this.connectionData = [farmNode];
          return;
        }
        
        // Process each wool line and add as connections to the farm
        const woolLinePromises = traceData.map(async trace => {
          const lineId = trace.LineID;
          if (!lineId) return null;
          
          // Create wool line node
          const woolLineNode = {
            id: `wool-${lineId}`,
            name: `Wool Line: ${lineId}`,
            type: 'wool_line',
            lineId: lineId,
            micron: trace.Micron_um,
            yield: trace.Yield_pct,
            connections: []
          };
          
          // Add wool line as a connection to the farm
          farmNode.connections.push(woolLineNode);
          
          // Get broker connection if available
          if (trace.BrokerCode) {
            const brokerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/brokers?BrokerCode=eq.${trace.BrokerCode}`, {
              method: 'GET',
              headers: {
                'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Content-Type': 'application/json'
              }
            });
            
            const brokerData = await brokerResponse.json();
            if (brokerData && brokerData.length > 0) {
              const broker = brokerData[0];
              const brokerNode = {
                id: `broker-${broker.BrokerCode}`,
                name: broker.BrokerName || broker.name || 'Unknown Broker',
                type: 'broker',
                code: broker.BrokerCode
              };
              
              // Add broker as a connection to the wool line
              woolLineNode.connections.push(brokerNode);
            }
          }
          
          // Get classer connection if available
          if (trace.ClasserID) {
            const classerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/classer_register?ClasserID=eq.${trace.ClasserID}`, {
              method: 'GET',
              headers: {
                'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Authorization': 'Bearer sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Content-Type': 'application/json'
              }
            });
            
            const classerData = await classerResponse.json();
            if (classerData && classerData.length > 0) {
              const classer = classerData[0];
              const classerNode = {
                id: `classer-${classer.ClasserID}`,
                name: classer.Name || 'Unknown Classer',
                type: 'classer',
                code: classer.ClasserID
              };
              
              // Add classer as a connection to the wool line
              woolLineNode.connections.push(classerNode);
            }
          }
          
          return woolLineNode;
        });
        
        // Wait for all wool line data to be fetched
        await Promise.all(woolLinePromises);
        
        // Flatten the connections for proper display
        // Start with the farm node
        const flattenedConnections = [farmNode];
        
        // Add all wool line nodes as separate items in the array
        if (farmNode.connections && farmNode.connections.length > 0) {
          farmNode.connections.forEach(woolLine => {
            // Add the wool line as a separate item
            flattenedConnections.push(woolLine);
            
            // Add broker and classer nodes as separate items
            if (woolLine.connections && woolLine.connections.length > 0) {
              woolLine.connections.forEach(connection => {
                flattenedConnections.push(connection);
              });
            }
          });
        }
        
        // Set the flattened connections as the main connection data
        this.connectionData = flattenedConnections;
        console.log('Farm connection data (flattened):', this.connectionData);
      } catch (error) {
        console.error('Error loading farm connections from Supabase:', error);
      }
    },
    
    async loadClasserConnectionsFromSupabase(classerId) {
      try {
        // Get the classer details first
        const classerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities?id=eq.${classerId}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Content-Type': 'application/json'
          }
        });
        
        const classerData = await classerResponse.json();
        if (!classerData || classerData.length === 0) {
          console.error('Classer not found');
          return;
        }
        
        const classer = classerData[0];
        const classerCode = classer.code;
        
        // Get wool lines associated with this classer using trace_index
        const traceResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?ClasserID=eq.${classerCode}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Content-Type': 'application/json'
          }
        });
        
        const traceData = await traceResponse.json();
        if (!traceData || traceData.length === 0) {
          console.error('No wool lines found for this classer');
          return;
        }
        
        // Process each wool line and fetch its connections
        const woolLinePromises = traceData.map(async trace => {
          const lineId = trace.LineID;
          const farmPIC = trace.PIC;
          
          // Get farm details
          const farmResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/farm_profiles?PIC=eq.${farmPIC}`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          const farmData = await farmResponse.json();
          const farmName = farmData && farmData.length > 0 ? farmData[0].name : 'Unknown Farm';
          
          // Get connections for this wool line
          const connections = [];
          
          // Add farm connection
          connections.push({
            id: `farm-${farmPIC}`,
            name: farmName,
            type: 'farm',
            pic: farmPIC
          });
          
          // Add testing lab if available
          if (trace.TestCertID) {
            connections.push({
              id: 'testing-lab-awta',
              name: 'Australian Wool Testing Authority',
              type: 'testing_lab',
              code: 'AWTA',
              certification: 'ISO 9001'
            });
          }
          
          // Add broker if available
          if (trace.BrokerCode) {
            // Fetch broker details
            const brokerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities?code=eq.${trace.BrokerCode}`, {
              method: 'GET',
              headers: {
                'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Content-Type': 'application/json'
              }
            });
            
            const brokerData = await brokerResponse.json();
            if (brokerData && brokerData.length > 0) {
              const broker = brokerData[0];
              connections.push({
                id: broker.id,
                name: broker.name,
                type: 'broker',
                code: broker.code,
                location: broker.location
              });
            }
          }
          
          return {
            id: `wool-${lineId}`,
            name: `Wool Line: ${lineId}`,
            lineId: lineId,
            type: 'wool_line',
            farmName: farmName,
            farmPIC: farmPIC,
            micron: trace.Micron_um,
            yield: trace.Yield_pct,
            connections: connections
          };
        });
        
        // Wait for all wool line data to be fetched
        const woolLines = await Promise.all(woolLinePromises);
        this.connectionData = woolLines.filter(line => line !== null);
      } catch (error) {
        console.error('Error loading classer connections from Supabase:', error);
      }
    },
    
    async loadWoolLineConnectionsFromSupabase(woolLineId) {
      try {
        // Extract the actual LineID from the wool-{LineID} format if needed
        const lineId = woolLineId.startsWith('wool-') ? woolLineId.substring(5) : woolLineId;
        
        // Get wool line details from trace_index
        const traceResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?LineID=eq.${lineId}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Content-Type': 'application/json'
          }
        });
        
        const traceData = await traceResponse.json();
        if (!traceData || traceData.length === 0) {
          console.error('Wool line not found');
          return;
        }
        
        const trace = traceData[0];
        const farmPIC = trace.PIC;
        const classerID = trace.ClasserID;
        const brokerCode = trace.BrokerCode;
        const testCertID = trace.TestCertID;
        
        // Create connections array
        const connections = [];
        
        // Add farm connection
        if (farmPIC) {
          const farmResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/farm_profiles?PIC=eq.${farmPIC}`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          const farmData = await farmResponse.json();
          if (farmData && farmData.length > 0) {
            const farm = farmData[0];
            connections.push({
              id: `farm-${farmPIC}`,
              name: farm.name,
              type: 'farm',
              pic: farmPIC
            });
          }
        }
        
        // Add classer connection
        if (classerID) {
          const classerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities?code=eq.${classerID}`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          const classerData = await classerResponse.json();
          if (classerData && classerData.length > 0) {
            const classer = classerData[0];
            connections.push({
              id: classer.id,
              name: classer.name,
              type: 'classer',
              code: classer.code
            });
          }
        }
        
        // Add testing lab connection
        if (testCertID) {
          connections.push({
            id: 'testing-lab-awta',
            name: 'Australian Wool Testing Authority',
            type: 'testing_lab',
            code: 'AWTA',
            certification: 'ISO 9001'
          });
        }
        
        // Add broker connection
        if (brokerCode) {
          const brokerResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities?code=eq.${brokerCode}`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          const brokerData = await brokerResponse.json();
          if (brokerData && brokerData.length > 0) {
            const broker = brokerData[0];
            connections.push({
              id: broker.id,
              name: broker.name,
              type: 'broker',
              code: broker.code
            });
          }
        }
        
        // Create the wool line node with its connections
        const woolLineNode = {
          id: `wool-${lineId}`,
          name: `Wool Line: ${lineId}`,
          lineId: lineId,
          type: 'wool_line',
          micron: trace.Micron_um,
          yield: trace.Yield_pct,
          connections: connections
        };
        
        this.connectionData = [woolLineNode];
      } catch (error) {
        console.error('Error loading wool line connections from Supabase:', error);
      }
    },
    
    async loadCommercialEntityConnectionsFromSupabase(entityId, entityType) {
      try {
        // Get the commercial entity details
        const entityResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/commercial_entities?id=eq.${entityId}`, {
          method: 'GET',
          headers: {
            'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
            'Content-Type': 'application/json'
          }
        });
        
        const entityData = await entityResponse.json();
        if (!entityData || entityData.length === 0) {
          console.error('Commercial entity not found');
          return;
        }
        
        const entity = entityData[0];
        const entityCode = entity.code;
        
        // Different queries based on entity type
        let traceData = [];
        
        if (entityType === 'broker') {
          // Get wool lines associated with this broker
          const traceResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?BrokerCode=eq.${entityCode}`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          traceData = await traceResponse.json();
        } else if (entityType === 'testing_lab') {
          // For testing labs, we need to find wool lines with test certificates
          const traceResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?TestCertID=neq.null`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          traceData = await traceResponse.json();
          // Limit to a reasonable number for demo
          traceData = traceData.slice(0, 5);
        } else if (entityType === 'shipping_company' || entityType === 'factory' || entityType === 'brand') {
          // For these entities, we'll use a sample of wool lines
          const traceResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/trace_index?limit=5`, {
            method: 'GET',
            headers: {
              'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
              'Content-Type': 'application/json'
            }
          });
          
          traceData = await traceResponse.json();
        }
        
        if (!traceData || traceData.length === 0) {
          console.error('No wool lines found for this commercial entity');
          return;
        }
        
        // Process each wool line and fetch its connections
        const woolLinePromises = traceData.map(async trace => {
          const lineId = trace.LineID;
          const farmPIC = trace.PIC;
          
          // Get farm details
          let farmName = 'Unknown Farm';
          if (farmPIC) {
            const farmResponse = await fetch(`https://lecugcvaoiurbfwastkh.supabase.co/rest/v1/farm_profiles?PIC=eq.${farmPIC}`, {
              method: 'GET',
              headers: {
                'apikey': 'sb_publishable_yrXuLpXbBxjnfu9s0WhZ2A_-oZCQo3V',
                'Content-Type': 'application/json'
              }
            });
            
            const farmData = await farmResponse.json();
            if (farmData && farmData.length > 0) {
              farmName = farmData[0].name;
            }
          }
          
          // Get connections for this wool line
          const connections = [];
          
          // Add farm connection
          connections.push({
            id: `farm-${farmPIC}`,
            name: farmName,
            type: 'farm',
            pic: farmPIC
          });
          
          // For shipping companies, add port connection
          if (entityType === 'shipping_company') {
            connections.push({
              id: `port-${Math.random().toString(36).substring(7)}`,
              name: Math.random() > 0.5 ? 'Port Botany' : 'Port of Brisbane',
              type: 'port',
              location: Math.random() > 0.5 ? 'Sydney, NSW' : 'Brisbane, QLD'
            });
          }
          
          // For factories, add brand connection
          if (entityType === 'factory') {
            connections.push({
              id: `brand-${Math.random().toString(36).substring(7)}`,
              name: Math.random() > 0.5 ? 'Patagonia' : 'Icebreaker',
              type: 'brand'
            });
          }
          
          return {
            id: `wool-${lineId}`,
            name: `Wool Line: ${lineId}`,
            lineId: lineId,
            type: 'wool_line',
            farmName: farmName,
            farmPIC: farmPIC,
            micron: trace.Micron_um,
            yield: trace.Yield_pct,
            connections: connections
          };
        });
        
        // Wait for all wool line data to be fetched
        const woolLines = await Promise.all(woolLinePromises);
        this.connectionData = woolLines.filter(line => line !== null);
      } catch (error) {
        console.error('Error loading commercial entity connections from Supabase:', error);
      }
    },
    
    async loadCommercialEntityConnections(entityId, entityType) {
      // For demo purposes, create sample connections based on entity type
      // In a real app, this would fetch from your API
      
      // Get wool lines associated with this commercial entity
      const relatedWoolLines = await this.getMockRelatedWoolLines(entityId, entityType);
      
      // Add wool lines as first-level connections
      this.connectionData = relatedWoolLines.map(woolLine => {
        // For each wool line, add the farm as a second-level connection
        const connections = [];
        
        // Add farm for this wool line
        if (woolLine.FarmName) {
          connections.push({
            id: `farm-${woolLine.PIC || 'unknown'}`,
            name: woolLine.FarmName,
            type: 'farm',
            pic: woolLine.PIC
          });
        }
        
        // For shipping companies, add ports
        if (entityType === 'shipping_company' && woolLine.PortID) {
          connections.push({
            id: `port-${woolLine.PortID}`,
            name: this.getPortName(woolLine.PortID),
            type: 'port',
            code: woolLine.PortID
          });
        }
        
        // For factories, add brands
        if (entityType === 'factory' && woolLine.Brand) {
          connections.push({
            id: `brand-${woolLine.Brand}`,
            name: woolLine.Brand,
            type: 'brand'
          });
        }
        
        return {
          id: `wool-${woolLine.LineID}`,
          name: `Wool Line: ${woolLine.LineID}`,
          lineId: woolLine.LineID,
          type: 'wool_line',
          farmName: woolLine.FarmName,
          micron: woolLine.Micron_um,
          yield: woolLine.Yield_pct,
          connections: connections
        };
      });
      
      // For certain entity types, add additional connections
      if (['broker', 'auction_house'].includes(entityType)) {
        // Add some factories as connections
        this.connectionData.push({
          id: 'factory-cn-shz-01',
          name: 'Suzhou Wool Textile Co.',
          type: 'factory',
          code: 'CN-SHZ-01',
          location: 'Suzhou, China'
        });
      }
    },
    
    async getMockWoolLines(farmId) {
      // In a real app, this would fetch from your API
      // For demo, return mock data
      return [
        {
          LineID: 'KOO-25-001',
          FarmName: this.selectedItem.name,
          ClasserID: 'C1234',
          ClasserName: 'Robert Lee',
          TestCertID: 'AWTA-9876',
          Micron_um: 19.5,
          Yield_pct: 68,
          BrokerCode: 'B5678',
          BrokerName: 'Taylor Goldin Classer'
        },
        {
          LineID: 'KOO-25-002',
          FarmName: this.selectedItem.name,
          ClasserID: 'C1234',
          ClasserName: 'Robert Lee',
          TestCertID: 'AWTA-9877',
          Micron_um: 20.1,
          Yield_pct: 70,
          BrokerCode: 'B5678',
          BrokerName: 'Taylor Goldin Classer'
        },
        {
          LineID: 'KOO-25-003',
          FarmName: this.selectedItem.name,
          ClasserID: 'C5678',
          ClasserName: 'Jessica Huang',
          TestCertID: 'AWTA-9878',
          Micron_um: 18.7,
          Yield_pct: 65,
          BrokerCode: 'B1234',
          BrokerName: 'Jordan Alex Pty Ltd'
        }
      ];
    },
    
    async getMockRelatedWoolLines(entityId, entityType) {
      // In a real app, this would fetch from your API
      // For demo, return mock data based on entity type
      
      // Create a base set of wool lines
      const baseWoolLines = [
        {
          LineID: 'KOO-25-001',
          FarmName: 'Ironbark Station',
          PIC: 'NSW123456',
          Micron_um: 19.5,
          Yield_pct: 68,
          PortID: 'AUS-NSW-PBT',
          Brand: 'Patagonia'
        },
        {
          LineID: 'KOO-25-002',
          FarmName: 'Ironbark Station',
          PIC: 'NSW123456',
          Micron_um: 20.1,
          Yield_pct: 70,
          PortID: 'AUS-QLD-BNE',
          Brand: 'Icebreaker'
        },
        {
          LineID: 'MER-22-005',
          FarmName: 'Merriwa Farms',
          PIC: 'NSW789012',
          Micron_um: 18.7,
          Yield_pct: 65,
          PortID: 'AUS-NSW-PBT',
          Brand: 'Patagonia'
        }
      ];
      
      // Return a subset based on entity type
      if (entityType === 'classer') {
        return baseWoolLines.slice(0, 2);
      } else if (entityType === 'broker') {
        return baseWoolLines;
      } else if (entityType === 'testing_lab') {
        return baseWoolLines;
      } else if (entityType === 'auction_house') {
        return baseWoolLines.slice(1, 3);
      } else if (entityType === 'shipping_company') {
        return baseWoolLines;
      } else if (entityType === 'factory') {
        return baseWoolLines.slice(0, 2);
      } else if (entityType === 'brand') {
        return baseWoolLines.filter(line => line.Brand === this.selectedItem.name);
      } else {
        return baseWoolLines.slice(0, 1);
      }
    },
    
    getPortName(portId) {
      const portMap = {
        'AUS-NSW-PBT': 'Port Botany',
        'AUS-QLD-BNE': 'Port of Brisbane',
        'AUS-VIC-MEL': 'Port of Melbourne'
      };
      
      return portMap[portId] || portId;
    },
    
    openModal() {
      this.showModal = true
    },
    
    closeModal() {
      this.showModal = false
      this.selectedItem = null
    },
    
    formatKey(key) {
      // Convert camelCase or snake_case to Title Case with spaces
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    },
    
    handleClickOutside(event) {
      // Close dropdown when clicking outside
      if (this.showSortDropdown && !event.target.closest('.sort-dropdown')) {
        this.showSortDropdown = false;
      }
    },
    
    generateAiResponse(userInput) {
      // Simple AI response simulation based on keywords
      const input = userInput.toLowerCase();
      
      if (input.includes('wool') || input.includes('micron')) {
        return "I can help you analyze wool quality metrics. The current wool line shows micron measurements and quality grades. Would you like me to explain any specific wool characteristics?";
      } else if (input.includes('farm') || input.includes('sustainability')) {
        return "This supply chain includes sustainable farming practices. I can provide details about farm certifications, carbon footprint, and animal welfare standards. What specific aspect interests you?";
      } else if (input.includes('trace') || input.includes('supply chain')) {
        return "The traceability data shows the complete journey from farm to fabric. I can walk you through each stage of the supply chain. Which part would you like to explore?";
      } else if (input.includes('price') || input.includes('cost')) {
        return "I can analyze pricing data across the supply chain. This includes farm gate prices, processing costs, and final fabric pricing. What pricing information do you need?";
      } else {
        return "I'm here to help you understand this wool supply chain data. You can ask me about wool quality, farm sustainability, traceability, pricing, or any other aspect of the supply chain.";
      }
    }
  }
}
</script>

<style scoped>
.search-container {
  min-height: 100vh;
  display: flex;
  position: relative;
  margin: 0;
  padding: 0;
}


/* Left Sidebar Styles */
.left-sidebar {
  width: 200px; /* Reduced to give more space to content */
  background-color: #F5F8F7;
  border-right: 1px solid #EAEAEA;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 0 0; /* Remove bottom padding to accommodate industry selector */
  height: 100vh;
  position: sticky;
  top: 0;
  overflow-y: auto;
}

.sidebar-logo {
  margin-bottom: 40px;
  padding: 0 24px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.nav-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 20px;
  color: #6C7972;
  text-decoration: none;
  font-size: 12px;
  gap: 16px;
  transition: all 0.2s ease;
}

.nav-item:hover {
  color: #3A895F;
}

.nav-item:hover svg path {
  fill: #3A895F;
}

.nav-item.active {
  color: #3A895F;
  position: relative;
  background-color: rgba(58, 137, 95, 0.1);
  border-left: 3px solid #3A895F;
}

.nav-item.active svg path {
  fill: #3A895F;
}

/* Recent Section Styles */
.sidebar-section {
  width: 100%;
  margin-top: 40px;
  padding: 0 20px;
}

.section-title {
  font-size: 12px;
  font-weight: 500;
  color: #6C7972;
  margin-bottom: 12px;
  padding-left: 8px;
}

.recent-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recent-item {
  font-size: 12px;
  color: #6C7972;
  text-decoration: none;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: pointer;
}

.recent-item:hover {
  background-color: rgba(58, 137, 95, 0.1);
  color: #3A895F;
}

.recent-item-type {
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  opacity: 0.7;
}

.recent-item-name {
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Toggle Switch Styles */
.toggle-bg {
  position: relative;
}

.toggle-bg:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 9999px;
}

.toggle-dot {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.main-content {
  flex: 1;
  padding: 0;
  padding-left: 40px;
  padding-right: 40px; /* Consistent with left padding */
  background-color: #FFFFFF;
  margin-left: 0px;
  margin-top: 0;
  min-height: 100vh;
  transition: padding-right 0.3s ease, margin-right 0.3s ease, width 0.3s ease;
}

/* Apply right padding only when the AI panel is showing (when selectedItem exists) */
.main-content.with-ai-panel {
  padding-right: 440px; /* 400px for panel width + 40px for consistent padding */
  width: calc(100% - 440px); /* Ensure content doesn't overlap with panel */
}


/* Full width main content when sidebar is hidden */
.main-content.full-width {
  margin-left: 0;
  padding-left: 0;
  border-left: none !important;
}

/* Ensure no left border on these components */
.pre-audit-guidance, .audit-findings {
  border-left: none !important;
}

.main-container {
  padding-top: 0;
  margin-top: 0;
}

.main-container.full-width {
  width: 100%;
  max-width: 100%;
  border-left: none !important;
}

.search-container {
  display: flex;
}

.search-form-container {
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 80vh;
  transition: min-height 0.3s ease;
}

.search-form-container.with-results {
  min-height: 30vh;
  padding-bottom: 1rem;
}

.search-header {
  text-align: center;
  margin-bottom: 2rem;
  transition: margin-bottom 0.3s ease;
}

.search-header.mb-reduced {
  margin-bottom: 1rem;
}

/* Chat Page Styles */
.chat-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  height: calc(100vh - 4rem);
  display: flex;
  flex-direction: column;
}

.chat-page-header {
  margin-bottom: 2rem;
  flex-shrink: 0;
}

.chat-page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}

.chat-page-separator {
  width: 100%;
  height: 1px;
  background: #e5e7eb;
}

.chat-header {
  margin-bottom: 1.5rem;
  flex-shrink: 0;
}

.chat-header h1 {
  font-size: 2rem;
  font-weight: 600;
  color: #1f2937;
}

.chat-header p {
  font-size: 1.125rem;
  color: #6b7280;
  margin-top: 0.5rem;
}

/* Custom Chat Container */
.custom-chat-container {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: white;
  display: flex;
  flex-direction: column;
}

.custom-chat-messages {
  background: #ffffff;
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* User Messages (You) - Right side, green with label */
.custom-message-wrapper.user {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.custom-message-bubble.user {
  background: #F5F8F7;
  color: #1f2937;
  border-radius: 20px;
  border-bottom-right-radius: 4px;
  padding: 0.875rem 1.125rem;
  max-width: 65%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 0.9375rem;
  line-height: 1.5;
  word-wrap: break-word;
  position: relative;
  margin-bottom: 0.25rem;
  border: 1px solid #E7EEEA;
}

.custom-message-bubble.user::after {
  content: none;
}

/* Bot Messages (Atralis) - Left side, no background */
.custom-message-wrapper.bot {
  display: flex;
  justify-content: flex-start;
  padding-left: 0;
  margin-bottom: 1rem;
}

.custom-message-bubble.bot {
  background: transparent;
  color: #1f2937;
  border-radius: 0;
  padding: 0;
  max-width: 100%;
  box-shadow: none;
  font-size: 0.9375rem;
  line-height: 1.5;
  word-wrap: break-word;
  position: relative;
  margin-bottom: 0.25rem;
  border: none;
}

/* Markdown Formatting in Messages */
.custom-message-content {
  word-break: break-word;
}

.custom-message-content p {
  margin: 0 0 0.75rem 0;
}

.custom-message-content p:last-child {
  margin-bottom: 0;
}

.custom-message-content h1,
.custom-message-content h2,
.custom-message-content h3,
.custom-message-content h4 {
  margin: 1rem 0 0.5rem 0;
  font-weight: 600;
  line-height: 1.3;
}

.custom-message-content h1 {
  font-size: 1.5rem;
}

.custom-message-content h2 {
  font-size: 1.25rem;
}

.custom-message-content h3 {
  font-size: 1.125rem;
}

.custom-message-content h4 {
  font-size: 1rem;
}

.custom-message-content ul,
.custom-message-content ol {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

.custom-message-content li {
  margin: 0.25rem 0;
}

.custom-message-content code {
  background: rgba(0, 0, 0, 0.1);
  padding: 0.125rem 0.375rem;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
}

.custom-message-bubble.user .custom-message-content code {
  background: rgba(0, 0, 0, 0.05);
}

.custom-message-content pre {
  background: rgba(0, 0, 0, 0.05);
  padding: 0.75rem;
  border-radius: 8px;
  overflow-x: auto;
  margin: 0.75rem 0;
}

.custom-message-content pre code {
  background: none;
  padding: 0;
}

.custom-message-content blockquote {
  border-left: 3px solid #3A895F;
  padding-left: 1rem;
  margin: 0.75rem 0;
  font-style: italic;
  opacity: 0.9;
}

.custom-message-content a {
  color: #3A895F;
  text-decoration: underline;
}

.custom-message-bubble.user .custom-message-content a {
  color: #3A895F;
  font-weight: 600;
}

.custom-message-content strong {
  font-weight: 600;
}

.custom-message-content em {
  font-style: italic;
}

.custom-message-content hr {
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin: 1rem 0;
}

.custom-message-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.75rem 0;
  font-size: 0.875rem;
}

.custom-message-content th,
.custom-message-content td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  text-align: left;
}

.custom-message-content th {
  background: rgba(0, 0, 0, 0.05);
  font-weight: 600;
}

/* Chart Container in Messages */
.message-chart-container {
  margin-top: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 1px #E7EEEA;
}

.custom-message-bubble.user .message-chart-container {
  background: rgba(255, 255, 255, 0.5);
}

.message-chart-container canvas {
  max-width: 100%;
  height: auto !important;
  max-height: 400px;
}

.custom-message-bubble.bot::before {
  content: none;
}

.custom-message-bubble.bot::after {
  content: none;
}

/* Input Area */
.custom-chat-input-container {
  background: white;
  padding: 1.25rem 1.5rem;
  flex-shrink: 0;
}

.custom-chat-input-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  background: #FAFBFB;
  border-radius: 8px;
  padding: 1rem;
  border: 2px solid #E7EEEA;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  min-height: 130px;
}

.custom-chat-input {
  border: none;
  padding: 0;
  padding-top: 0.25rem;
  font-size: 0.9375rem;
  transition: all 0.2s;
  flex: 1;
  background: transparent;
  font-family: inherit;
  line-height: 1.5;
  align-self: flex-start;
}

.custom-chat-input:focus {
  outline: none;
}

.custom-chat-input::placeholder {
  color: #9ca3af;
}

.custom-chat-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  align-self: flex-end;
}

.custom-chat-icon-btn {
  background: #E7EEEA;
  border: none;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.2s;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
}

.custom-chat-icon-btn svg path {
  fill: #93A099;
}

.custom-chat-icon-btn:hover {
  background: #d9e4dd;
}

.custom-chat-go-btn {
  background: #3A895F;
  color: white;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-size: 0.9375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  min-width: 44px;
}

.custom-chat-go-btn:hover:not(:disabled) {
  background: #2d6b4a;
}

.custom-chat-go-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Loading Indicator */
.custom-loading-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.custom-loading-icon {
  flex-shrink: 0;
}

.custom-loading-text {
  color: #3A895F;
  font-size: 0.9375rem;
  font-weight: 500;
}

.chat-loader-overlay {
  animation: dash-loader 1.5s ease-in-out infinite;
  stroke-dasharray: 600;
  stroke-dashoffset: 0;
}

@keyframes rotate-loader {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes dash-loader {
  0% {
    stroke-dashoffset: 600;
  }
  50% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -600;
  }
}

@keyframes typing-bounce {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-8px);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.search-box {
  position: relative;
}

.search-results {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 1rem;
}

.results-header {
  margin-bottom: 1.5rem;
}

.item-detail-view {
  max-width: 1200px;
  margin: 0 auto;
}

.tab-content {
  margin-top: 1.5rem;
}

.main-content-area {
  flex: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.searching-results {
  text-align: center;
  margin-top: 0.25rem;
  color: #3A895F;
}

.no-results {
  text-align: center;
  margin-top: 2rem;
  color: #6b7280;
}

/* Detail View Styles */
.detail-header {
  margin-bottom: 1.5rem;
}

.back-button {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.2s;
}

.tab-navigation {
  margin-top: 1rem;
}

.metric-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.certification-badge {
  display: inline-block;
}

/* Farm Details Styles */
.farm-header {
  margin-bottom: 1.5rem;
}

.farm-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.farm-image {
  border-radius: 0.5rem;
  overflow: hidden;
  height: 12rem;
}

.farm-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.farm-description {
  margin-top: 1rem;
  line-height: 1.6;
}

.farm-details-tab h2.text-green-700 {
  color: #3A895F;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.farm-details-tab h3.text-md {
  font-size: 0.875rem;
  color: #6B7280;
}

/* Data Ingestion Styles */
.data-ingestion-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

/* SVG Loader Animation Styles */
#loader-overlay {
  stroke-dasharray: 70 470;
  stroke-dashoffset: 0;
  animation: perimeter 3s linear infinite;
  stroke-linecap: round;
}

@keyframes perimeter {
  to {
    stroke-dashoffset: -540;
  }
}

/* ============================================
   MOBILE RESPONSIVE STYLES
   ============================================ */

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1001;
  background: #3A895F;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.mobile-menu-btn:hover {
  background: #2d6f4a;
  transform: scale(1.05);
}

.mobile-menu-btn:active {
  transform: scale(0.95);
}

/* Mobile Overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Mobile Close Button in Sidebar */
.mobile-close-btn {
  display: none;
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #6C7972;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.mobile-close-btn:hover {
  background: rgba(108, 121, 114, 0.1);
  color: #3A895F;
}

/* Mobile AI Panel Toggle Button - Hidden on desktop by default */
.mobile-ai-toggle-btn {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 900;
  background: #3A895F;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 14px 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(58, 137, 95, 0.3);
  font-size: 14px;
  font-weight: 500;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.mobile-ai-toggle-btn:hover {
  background: #2d6f4a;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(58, 137, 95, 0.4);
}

.mobile-ai-toggle-btn.panel-open {
  display: none;
}

/* AI Panel Wrapper */
.ai-panel-wrapper {
  position: relative;
}

/* Mobile AI Panel Close Button */
.mobile-ai-close-btn {
  display: none;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1001;
  background: white;
  border: 1px solid #EAEAEA;
  color: #6C7972;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.mobile-ai-close-btn:hover {
  background: #f5f5f5;
  color: #3A895F;
}

/* ============================================
   MEDIA QUERIES
   ============================================ */

/* Tablet and below (768px) */
@media (max-width: 768px) {
  /* Prevent horizontal overflow */
  * {
    box-sizing: border-box;
  }
  
  html, body {
    overflow-x: hidden;
    max-width: 100vw;
  }
  
  .search-container {
    max-width: 100vw;
    overflow-x: hidden;
  }
  
  /* Show mobile menu button */
  .mobile-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* Hide sidebar by default on mobile */
  .left-sidebar {
    position: fixed;
    left: -100%;
    top: 0;
    height: 100vh;
    z-index: 1000;
    transition: left 0.3s ease;
    width: 280px;
    overflow-y: auto;
    box-sizing: border-box;
  }
  
  /* Show sidebar when open */
  .left-sidebar.mobile-open {
    left: 0;
  }
  
  /* Show mobile overlay when sidebar is open */
  .mobile-overlay {
    display: block;
  }
  
  /* Show mobile close button */
  .left-sidebar .mobile-close-btn {
    display: block;
  }
  
  /* Adjust main content */
  .main-content {
    padding-left: 16px !important;
    padding-right: 16px !important;
    padding-top: 70px; /* Add space for mobile menu button */
    width: 100% !important;
    max-width: 100vw;
    overflow-x: hidden;
  }
  
  .main-content.with-ai-panel {
    padding-right: 16px !important;
    width: 100% !important;
  }
  
  /* Ensure main container doesn't overflow */
  .main-container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }
  
  /* Show mobile AI toggle button */
  .mobile-ai-toggle-btn {
    display: flex;
  }
  
  /* Hide AI panel by default on mobile */
  .ai-panel-wrapper {
    position: fixed !important;
    right: -100% !important;
    top: 0;
    height: 100vh;
    width: 90%;
    max-width: 400px;
    z-index: 1000;
    background: white;
    transition: right 0.3s ease;
    overflow-y: auto;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
  }
  
  /* Override AIAssistantPanel's fixed positioning on mobile */
  .ai-panel-wrapper .ai-assistant-panel {
    position: relative !important;
    right: auto !important;
    top: auto !important;
    height: 100% !important;
    width: 100% !important;
  }
  
  /* Show AI panel when open */
  .ai-panel-wrapper.mobile-open {
    right: 0 !important;
  }
  
  .ai-panel-wrapper.mobile-open .mobile-ai-close-btn {
    display: block;
  }
  
  /* Adjust search form */
  .search-form-container {
    padding: 16px;
    padding-top: 70px; /* Add space for mobile menu button */
  }
  
  .search-header h1 {
    font-size: 1.5rem;
  }
  
  .search-header p {
    font-size: 1rem;
  }
  
  /* Adjust search results */
  .search-results {
    padding: 16px;
    margin-top: 0;
  }
  
  /* Search result items */
  .result-item {
    padding: 12px;
    margin-bottom: 12px;
  }
  
  .result-item h3 {
    font-size: 16px;
  }
  
  .result-item p {
    font-size: 14px;
  }
  
  /* Search result groups */
  .result-group {
    margin-bottom: 24px;
  }
  
  .result-group h2 {
    font-size: 18px;
    margin-bottom: 12px;
  }
  
  /* Hide farm images on mobile */
  .farm-images {
    display: none;
  }
  
  /* Adjust tabs for mobile */
  .tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .tabs::-webkit-scrollbar {
    display: none;
  }
  
  .tab {
    white-space: nowrap;
    font-size: 13px;
    padding: 10px 16px;
    min-width: auto;
  }
  
  /* Adjust detail panels */
  .detail-panel {
    padding: 16px;
  }
  
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .detail-header h2 {
    font-size: 20px;
  }
  
  /* Adjust metric cards */
  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .metric-card {
    padding: 16px;
  }
  
  .metric-card h3 {
    font-size: 14px;
  }
  
  .metric-card .value {
    font-size: 24px;
  }
  
  /* Buttons */
  button, .btn {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px; /* Touch-friendly */
  }
  
  /* Input fields */
  input, textarea, select {
    font-size: 16px; /* Prevents zoom on iOS */
    padding: 12px;
    min-height: 44px;
  }
  
  /* Search box */
  .search-box {
    width: 100%;
    padding: 0 16px;
  }
  
  .search-box input {
    font-size: 16px;
    padding: 14px 16px;
    padding-right: 80px; /* Make room for icons */
  }
  
  /* Adjust icon spacing in search box */
  .search-box .absolute.right-2 {
    right: 8px;
  }
  
  .search-box .flex.space-x-2 {
    gap: 1px !important; /* Remove gap between icons */
    margin: 0 !important;
  }
  
  .search-box .flex.space-x-2 button {
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .search-box button svg {
    width: 32px;
    height: 32px;
  }
  
  /* Cards and containers */
  .card {
    padding: 16px;
    margin-bottom: 16px;
  }
  
  /* Info sections */
  .info-section {
    padding: 16px;
    margin-bottom: 16px;
  }
  
  .info-section h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }
  
  /* Lists */
  .info-list {
    gap: 8px;
  }
  
  .info-list-item {
    padding: 12px;
    font-size: 14px;
  }
  
  /* Badges and tags */
  .badge, .tag {
    padding: 4px 8px;
    font-size: 12px;
  }
  
  /* Sidebar navigation adjustments */
  .nav-item {
    padding: 14px 20px;
    font-size: 14px;
  }
  
  .nav-item span {
    display: inline;
  }
  
  /* Connection graph adjustments */
  .connections-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  /* Timeline adjustments */
  .timeline {
    padding-left: 20px;
  }
  
  .timeline-item {
    padding: 12px;
    margin-bottom: 12px;
  }
  
  /* Modal adjustments */
  .modal-content {
    width: 95%;
    max-width: 95%;
    margin: 20px auto;
    max-height: 90vh;
    overflow-y: auto;
  }
  
  /* Image containers */
  .image-container {
    max-height: 250px;
  }
  
  /* Status indicators */
  .status-indicator {
    font-size: 13px;
    padding: 6px 12px;
  }
  
  /* Chat mobile styles */
  .chat-wrapper {
    padding: 1rem;
    height: calc(100vh - 2rem);
  }
  
  .chat-header h1 {
    font-size: 1.5rem;
  }
  
  .chat-header p {
    font-size: 1rem;
  }
  
  .custom-message-bubble.user,
  .custom-message-bubble.bot {
    max-width: 80%;
    font-size: 0.875rem;
  }
  
  .custom-chat-messages {
    padding: 1rem;
  }
  
  .custom-chat-input-container {
    padding: 0.75rem 1rem;
  }
  
  .custom-chat-input {
    font-size: 16px; /* Prevent iOS zoom */
  }
  
  .custom-chat-send-btn {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
  
  .custom-message-bubble.bot::before {
    left: -2.25rem;
    width: 1.75rem;
    height: 1.75rem;
    font-size: 0.65rem;
  }
  
  .custom-message-wrapper.bot {
    padding-left: 2.5rem;
  }
  
  .custom-message-bubble.user::after,
  .custom-message-bubble.bot::after {
    font-size: 0.65rem;
    bottom: -1.1rem;
  }
}

/* Small mobile devices (480px) */
@media (max-width: 480px) {
  .mobile-menu-btn {
    top: 12px;
    left: 12px;
    padding: 10px;
  }
  
  .left-sidebar {
    width: 100%;
  }
  
  .ai-panel-wrapper {
    width: 100%;
    max-width: 100%;
  }
  
  .mobile-ai-toggle-btn {
    bottom: 16px;
    right: 16px;
    padding: 12px 20px;
    font-size: 13px;
  }
  
  .search-header h1 {
    font-size: 1.25rem;
    line-height: 1.3;
  }
  
  .search-header p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .main-content {
    padding-left: 12px;
    padding-right: 12px;
  }
  
  /* Adjust table responsiveness */
  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin: 0 -12px;
    padding: 0 12px;
  }
  
  table {
    font-size: 12px;
    min-width: 600px;
  }
  
  th, td {
    padding: 8px 6px;
    white-space: nowrap;
  }
  
  /* Smaller text on very small screens */
  .result-item h3 {
    font-size: 15px;
  }
  
  .result-item p {
    font-size: 13px;
  }
  
  .result-group h2 {
    font-size: 16px;
  }
  
  /* Compact metric cards */
  .metric-card {
    padding: 12px;
  }
  
  .metric-card h3 {
    font-size: 13px;
  }
  
  .metric-card .value {
    font-size: 20px;
  }
  
  /* Smaller buttons */
  button, .btn {
    padding: 8px 14px;
    font-size: 13px;
    min-height: 40px;
  }
  
  /* Compact tabs */
  .tab {
    font-size: 12px;
    padding: 8px 12px;
  }
  
  /* Compact badges */
  .badge, .tag {
    padding: 3px 6px;
    font-size: 11px;
  }
  
  /* Detail header */
  .detail-header h2 {
    font-size: 18px;
  }
  
  /* Info sections */
  .info-section {
    padding: 12px;
  }
  
  .info-section h3 {
    font-size: 15px;
  }
  
  /* Search box */
  .search-box input {
    font-size: 15px;
    padding: 12px 14px;
  }
  
  /* Modal on small screens */
  .modal-content {
    width: 100%;
    margin: 10px auto;
    max-height: 95vh;
    border-radius: 8px 8px 0 0;
  }
  
  /* Image containers */
  .image-container {
    max-height: 200px;
  }
  
  /* Timeline */
  .timeline {
    padding-left: 16px;
  }
  
  .timeline-item {
    padding: 10px;
    font-size: 13px;
  }
}

/* Landscape mobile devices */
@media (max-width: 768px) and (orientation: landscape) {
  .left-sidebar {
    width: 240px;
  }
  
  .ai-panel-wrapper {
    width: 80%;
    max-width: 350px;
  }
}
</style>
/* Domain Graph Styles */
.domain-graph-wrapper {
  width: 100%;
  padding: 0;
  margin: 0;
}
